// ArChat Layout Fix
// Created: 12-03-2026 17:33:56
// Author: SIVOL® - Aldo Frias - Argentina

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsDe = {
                'login.title': 'Anmelden',
                'login.slogan': 'Gespräche ohne Grenzen!',
                'login.username': 'Benutzername',
                'login.password': 'Passwort',
                'login.submit': 'Anmelden',
                'login.loading': 'Laden...',
                'login.autoRegister.title': 'Automatische Registrierung',
                'login.autoRegister.description': 'Wenn Sie kein Konto haben, geben Sie Ihren Benutzernamen und Ihr Passwort ein. Es wird automatisch erstellt.',
                'login.forgotPassword': 'Passwort vergessen?',
                'login.passwordRecovery.title': 'Passwort wiederherstellen',
                'login.passwordRecovery.description': 'Geben Sie Ihre E-Mail ein, um einen Wiederherstellungslink zu erhalten.',
                'login.passwordRecovery.emailLabel': 'E-Mail',
                'login.passwordRecovery.emailPlaceholder': 'Geben Sie Ihre E-Mail ein',
                'login.passwordRecovery.emailHelp': 'Ein Wiederherstellungslink wird an Ihre E-Mail gesendet',
                'login.passwordRecovery.send': 'Senden',
                'login.passwordRecovery.success': 'Ein Wiederherstellungslink wurde an Ihre E-Mail gesendet. Überprüfen Sie Ihren Posteingang.',
                'login.passwordRecovery.successTitle': 'E-Mail gesendet',
                'login.passwordRecovery.successMessage': 'Wir haben Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts gesendet.\nBitte prüfen Sie Ihren Posteingang und den Spam-Ordner. Der Link kann einige Minuten brauchen.',
                'login.passwordRecovery.devExplanation': 'Im Entwicklungsmodus wird die E-Mail nicht an Ihren Posteingang gesendet; sie wird zur Vorschau gespeichert. Nutzen Sie „E-Mail anzeigen“, um den Inhalt und den Wiederherstellungslink zu sehen.',
                'login.passwordRecovery.devSinkNotice': '⚠️ Entwicklungsmodus: Diese E-Mail wurde NICHT an Ihren Posteingang gesendet. Nutzen Sie „E-Mail anzeigen“, um die generierte Nachricht und den Link zu öffnen.',
                'login.passwordRecovery.invalidEmail': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
                'login.error.invalidPassword': 'Ungültiges Passwort',
                'common.language': 'Sprache',
                'common.loading': 'Laden…',
                'common.back': 'Zurück',
                'common.backToStart': 'Zurück zur Startseite',
                'common.changeUser': 'Benutzer wechseln',
                'login.email.invalid': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
                'captcha.solve': 'Bitte lösen Sie das CAPTCHA korrekt',
                'captcha.generateError': 'Fehler beim Generieren des CAPTCHA. Bitte laden Sie die Seite neu.',
                'auth.require_email': 'E-Mail ist für die Registrierung erforderlich. Bitte geben Sie Ihre E-Mail ein.',
                'auth.invalid_credentials': 'Falscher Benutzername oder Passwort.',
                'auth.account_blocked': 'Konto inaktiv. Geben Sie Ihre E-Mail ein, um es zu reaktivieren.',
                'auth.device_limit_reached': 'Gerätelimit erreicht. Melden Sie sich auf einem anderen Gerät ab oder upgraden Sie Ihren Plan.',
                'auth.login.device_limit.title': 'Sitzungs- oder Gerätelimit erreicht',
                'auth.login.device_limit.body': 'Ihr Tarif erlaubt nur eine begrenzte Anzahl gleichzeitig aktiver Sitzungen oder Geräte. Melden Sie sich auf einem anderen Gerät ab oder beenden Sie eine andere aktive Sitzung, und versuchen Sie es erneut.',
                'auth.password_incorrect': 'Das Passwort ist falsch.',
                'auth.login.password_error_title': 'Falsches Passwort',
                'auth.login.password_attempts_hint': 'Sie haben 3 Versuche, Ihr Passwort korrekt einzugeben. Wenn Sie diese überschreiten, müssen Sie Ihr Passwort zurücksetzen.',
                'auth.login.password_attempts_exhausted_title': 'Versuchslimit erreicht',
                'auth.login.password_attempts_exhausted_body': 'Sie haben die 3 erlaubten Versuche überschritten. Setzen Sie Ihr Passwort über «Passwort vergessen?» zurück.',
                'auth.login.go_to_reset_password': 'Zur Passwortzurücksetzung',
                'auth.login.password_remaining_two': 'Sie haben noch 2 Versuche.',
                'auth.login.password_remaining_one': 'Sie haben noch 1 Versuch.',
                'auth.login.password_attempts_locked_inline': 'Maximale Anzahl an Versuchen erreicht. Sie müssen Ihr Passwort zurücksetzen.',
                'auth.account_inactive_email_mismatch': 'Konto inaktiv und die E-Mail stimmt nicht überein.',
                'auth.captcha_failed': 'CAPTCHA fehlerhaft. Überprüfen Sie Ihre Antwort.',
                'auth.captcha_expired': 'Ihre Verifizierung ist abgelaufen. Eine neue wurde automatisch erstellt.',
                'auth.unauthorized': 'Sie haben keine Berechtigung.',
                'auth.generic_error': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
                'auth.method_not_allowed': 'Methode nicht erlaubt.',
                'auth.invalid_data': 'Ungültige Daten.',
                'auth.credentials_required': 'Benutzername und Passwort sind erforderlich.',
                'auth.csrf_invalid': 'Ungültige Sitzung. Laden Sie die Seite neu und versuchen Sie es erneut.',
                'auth.username_taken': 'Dieser Benutzername ist bereits registriert. Melden Sie sich an oder wählen Sie einen anderen.',
                'auth.username_unavailable': 'Dieser Benutzername ist nicht verfügbar.',
                'auth.nick_no_spaces': 'Nicknames cannot contain spaces.',
                'auth.password_too_short': 'Das Passwort muss mindestens 6 Zeichen haben.',
                'auth.rate_limit': 'Zu viele Versuche. Warten Sie einen Moment und versuchen Sie es erneut.',
                'auth.confirm_success': 'Konto erfolgreich bestätigt. Weiterleitung zur Anmeldung...',
                'auth.confirm_already_active': 'Ihr Konto ist bereits aktiv. Sie können sich anmelden.',
                'auth.reset_sent': 'Wenn die E-Mail registriert ist, erhalten Sie Anweisungen zum Zurücksetzen Ihres Passworts.',
                'auth.reset_token_invalid': 'Ungültiger oder fehlender Link.',
                'auth.reset_token_expired': 'Dieser Link ist abgelaufen. Fordern Sie einen neuen unter "Passwort vergessen?" an.',
                'auth.reset_done': 'Passwort aktualisiert. Sie können sich jetzt anmelden.',
                'auth.reset_fatal': 'Fehler beim Speichern. Bitte später erneut versuchen.',
                'auth.password_mismatch': 'Die Passwörter stimmen nicht überein.',
                'resetPassword.page.title': 'Neues Passwort',
                'resetPassword.page.description': 'Geben Sie Ihr neues Passwort ein (mindestens 6 Zeichen).',
                'resetPassword.newPassword': 'Neues Passwort',
                'resetPassword.newPasswordPlaceholder': 'Mindestens 6 Zeichen',
                'resetPassword.submit': 'Passwort zurücksetzen',
                'resetPassword.success': 'Passwort aktualisiert. Weiterleitung zum Login...',
                'resetPassword.backToLogin': 'Zurück zum Login',

                'account.delete.section_title': 'Konto löschen',
                'account.delete.description': 'Wenn Sie Ihr Konto löschen, werden alle Daten, Nachrichten, Kontakte und Einstellungen dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
                'account.delete.button': 'Mein Konto löschen',
                'accountDeletion.title': 'Konto- und Datenlöschung',
                'accountDeletion.description': 'Fordern Sie die Löschung Ihres ArChat-Kontos und der zugehörigen Daten an.',
                'accountDeletion.openRequest': 'Konto- und Datenlöschung beantragen',
                'account.delete.confirm_title': 'Konto löschen',
                'account.delete.confirm_message': 'Möchten Sie Ihr Konto wirklich löschen? Es wird eine Bestätigungs-E-Mail an Ihren Posteingang gesendet. Die Löschung ist dauerhaft und unwiderruflich.',
                'account.delete.email_sent_title': 'E-Mail gesendet',
                'account.delete.email_sent': 'Wir haben Ihnen eine Bestätigungs-E-Mail gesendet. Prüfen Sie Ihren Posteingang und klicken Sie auf den Link, um die Löschung zu bestätigen.',
                'account.delete.error': 'Die Anfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
                'account.delete.confirm_page_title': 'Kontolöschung bestätigen',
                'account.delete.confirm_page_desc': 'Sie sind dabei, Ihr ArChat-Konto dauerhaft zu löschen. Alle Daten, Nachrichten, Kontakte und Einstellungen werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
                'account.delete.confirm_final_button': 'Ja, mein Konto dauerhaft löschen',
                'account.delete.cancel_go_back': 'Abbrechen und zurück',
                'account.delete.done_title': 'Konto gelöscht',
                'account.delete.done_message': 'Ihr Konto wurde erfolgreich gelöscht. Alle Daten wurden entfernt.',
                'account.delete_token_expired': 'Der Löschlink ist abgelaufen oder ungültig. Fordern Sie einen neuen in Ihrem Profil an.',
                'account.delete_token_invalid': 'Ungültiger oder fehlender Löschlink.',
                'account.delete_email_failed': 'Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte später erneut versuchen.',
                'account.delete_error': 'Fehler bei der Löschung. Bitte später erneut versuchen.',

                'auth.register_success_email_sent': 'Konto erfolgreich erstellt. Eine Bestätigungs-E-Mail wurde gesendet. Bitte prüfen Sie Ihren Posteingang (und den Spam-Ordner) und klicken Sie auf den Link zur Aktivierung.',
                'auth.register_success_email_pending': 'Konto erstellt, aber die Bestätigungs-E-Mail konnte nicht gesendet werden. Das Aktivierungstoken ist weiterhin gültig. Wenden Sie sich an den Administrator oder fordern Sie eine neue Bestätigungs-E-Mail an.',
                'auth.email_not_verified': 'Sie müssen Ihre E-Mail bestätigen, um das Konto zu aktivieren.',
                'auth.email_not_verified_title': 'Konto wartet auf Bestätigung',
                'auth.email_send_failed': 'E-Mail konnte nicht gesendet werden. Bitte erneut versuchen oder E-Mail ändern.',
                'auth.email_send_failed_title': 'E-Mail konnte nicht gesendet werden',
                'auth.register.email_failed.title': 'Konto erstellt',
                'auth.register.email_failed.message': 'Ihr Konto wurde erfolgreich erstellt, aber beim Senden der Bestätigungs-E-Mail ist ein Problem aufgetreten. Prüfen Sie den Spam-Ordner oder fordern Sie eine neue E-Mail an.',
                'auth.register.success.title': 'Konto erstellt',
                'auth.register.success.message': 'Konto erfolgreich erstellt. Eine Bestätigungs-E-Mail wurde gesendet. Bitte prüfen Sie Ihren Posteingang (und den Spam-Ordner) und klicken Sie auf den Link zur Aktivierung.',
                'auth.resend_sent': 'Bestätigungs-E-Mail erneut gesendet.',
                'auth.resend_email': 'E-Mail erneut senden',
                'auth.retry_resend': 'Erneut versuchen',
                'auth.change_email': 'E-Mail ändern',
                'auth.ver_email': 'E-Mail anzeigen',
                'auth.already_verified': 'Das Konto ist bereits bestätigt.',
                'auth.confirm_email_title': 'E-Mail bestätigen',
                'auth.confirm_email_text': 'Der Aktivierungslink wird gesendet an:',
                'auth.confirm_email_edit': 'Bearbeiten',
                'auth.confirm_email_confirm': 'Bestätigen',
                'auth.confirm_email_typo_hint': 'Meinten Sie ***@{suggestion}?',
                'brand.slogan': 'Die Kraft, verstanden zu werden – unabhängig von der Sprache',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': 'Die Kraft, verstanden zu werden – unabhängig von der Sprache',
                'home.tagline': 'Messaging mit automatischer Übersetzung',
                'home.login': 'Anmelden',
                'home.register': 'Konto erstellen',
                'home.language': 'Sprache',
                'terms.title': 'Allgemeine Geschäftsbedingungen',
                'terms.accept': 'Akzeptieren und Fortfahren',
                'terms.reject': 'Ablehnen',
                'terms.rejectShort': 'Ich akzeptiere nicht',
                'terms.readAndAccept': 'Ich habe die Allgemeinen Geschäftsbedingungen gelesen und akzeptiert',
                'terms.cancel': 'Abbrechen',
                'register.pageTitle': 'Konto erstellen',
                'register.pageSubtitle': 'Geben Sie Ihre Daten ein, um Ihr Konto zu erstellen.',
                'register.submitLabel': 'Konto erstellen',
                'register.confirm_title': 'Konto bestätigen',
                'register.confirm_message': 'Sie sind dabei, das Konto zu erstellen:',
                'register.confirm': 'Bestätigen',
                'register.login_link': 'Sie haben bereits ein Konto?',
                'register.password_hint': 'Mindestens 6 Zeichen',
                'register.checking': 'Überprüfung…',
                'register.username_taken': 'Dieser Benutzername ist bereits vergeben.',
                'register.available': 'Verfügbar',
                'register.emailAlreadyExists': 'Diese E-Mail ist bereits registriert.',
                'register.continue': 'Weiter',
                'common.request_id_label': 'Anfrage-ID',
                'login.demo.title': 'Demo-Zugang',
                'login.demo.credentials': 'Benutzer: demo / Passwort: demo',
                'captcha.label': 'Sicherheitsüberprüfung',
                'security.verification_title': 'Sicherheitsüberprüfung',
                'security.captcha_question': 'Verifizierungsfrage',
                'security.enter_answer': 'Antwort eingeben',
                'captcha.description': 'Lösen Sie die mathematische Operation, um zu überprüfen, dass Sie ein Mensch sind',
                'captcha.required': 'Sie müssen die CAPTCHA-Antwort eingeben, um fortzufahren.',
                'menu.conversations': 'Unterhaltungen',
                'menu.contacts': 'Kontakte',
                'menu.dashboard': 'Übersicht',
                'menu.profile': 'Mein Profil',
                'menu.settings': 'Einstellungen',
                'menu.help': 'Hilfe',
                'menu.logout': 'Abmelden',
                'menu.files': 'Meine Dateien',
                'reviews.menu_title': 'Bewertungen',
                'reviews.rate_archat': 'ArChat bewerten',
                'reviews.my_review': 'Meine Bewertung',
                'navbar.contacts': 'Kontakte',
                'navbar.profile': 'Mein Profil',
                'navbar.settings': 'Einstellungen',
                'navbar.logout': 'Abmelden',
                'navbar.status': 'Präsenz',
                'navbar.users': 'Benutzer',
                'navbar.no_blocked_users': 'Keine blockierten Benutzer',
                'navbar.blocked_users_title': 'Blockierte Benutzer',
                'contacts.blocked_users_title': 'Blockierte Benutzer',
                'contacts.country_label': 'Land',
                'contacts.not_reported': 'Nicht angegeben',
                'navbar.user_fallback': 'Benutzer {id}',
                'onboarding.welcome_title': 'Willkommen bei ArChat®',
                'onboarding.welcome_subtitle': 'Kommuniziere mit jeder Person in jeder Sprache.',
                'onboarding.step1': 'Schritt 1',
                'onboarding.step1_title': 'Schritt 1',
                'onboarding.step1_description': 'Lade deinen ersten Kontakt ein',
                'onboarding.step2': 'Schritt 2',
                'onboarding.step2_title': 'Schritt 2',
                'onboarding.step2_description': 'Sende deine erste Nachricht',
                'onboarding.invite_contact': 'Kontakt einladen',
                'onboarding.explore_archat': 'ArChat® erkunden',
                'help.how_archat_works': 'Wie ArChat® funktioniert',
                'help.registration': 'Registrierung',
                'help.private_invitations': 'Private Einladungen',
                'help.messaging': 'Nachrichten',
                'help.security': 'Sicherheit',
                'contacts.invite_contact': 'Kontakt einladen',
                'contacts.no_contacts': 'Keine Kontakte',
                'help.view_initial_guide': 'Erste Anleitung anzeigen',
                'suggestions.title': 'Vorschläge',
                'suggestions.form.title': 'Titel des Vorschlags',
                'suggestions.form.message': 'Beschreiben Sie Ihre Idee',
                'suggestions.form.submit': 'Vorschlag senden',
                'suggestions.send': 'Vorschlag senden',
                'suggestions.captcha_placeholder': 'Ergebnis',
                'suggestions.cooldown': 'Sie müssen {minutes} Minuten warten, bevor Sie einen weiteren Vorschlag senden.',
                'suggestions.success_title': 'Vorschlag gesendet',
                'suggestions.success_message': 'Ihr Vorschlag wurde erfolgreich gesendet. Vorgangsnummer: {id}',
                'suggestions.success': 'Vielen Dank für Ihren Vorschlag. Unser Team wird ihn prüfen.',
                'suggestions.success.title': 'Vielen Dank für Ihren Vorschlag!',
                'suggestions.success.reference': 'Referenz',
                'suggestions.success.review': 'Unser Team wird Ihre Idee prüfen.',
                'suggestions.success.email': 'Wir haben Ihnen auch eine Bestätigungs-E-Mail gesendet.',
                'suggestions.success.copy': 'Kopieren',
                'suggestions.success.copied': 'Referenz kopiert',
                'suggestions.form.required': 'Titel und Nachricht sind erforderlich.',
                'suggestions.error': 'Senden fehlgeschlagen. Bitte erneut versuchen.',
                'profile.title': 'Mein Profil',
                'profile.founderBadge': 'Gründer #{position}/{limit}',
                'profile.founderTooltip': 'Gründungsmitglied – Lebenslang eingefrorener Preis solange das Abo aktiv bleibt',
                'profile.founderMember': 'Gründungsmitglied',
                'profile.founderHeaderBadge': '★ Gründer #{position}/150',
                'profile.camera.access_denied': 'Kamera nicht erreichbar. Berechtigungen prüfen.',
                'profile.edit': 'Bearbeiten',
                'profile.save': 'Änderungen speichern',
                'profile.save.success': 'Ihr Profil wurde erfolgreich aktualisiert.',
                'profile.save.success.title': 'Profil Aktualisiert',
                'profile.update.success.title': 'Profil Aktualisiert',
                'profile.update.success.message': 'Deine Änderungen wurden gespeichert.',
                'profile.save.error': 'Profil konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
                'profile.save.error.title': 'Speicherfehler',
                'profile.cancel': 'Abbrechen',
                'profile.nick': 'Benutzername',
                'profile.nick.help': 'Ihr eindeutiger Bezeichner im System',
                'profile.nick.readonly': 'Der Benutzername kann nicht geändert werden',
                'profile.nick.readonly.help': 'Der Benutzername ist eindeutig und kann nicht geändert werden',
                'profile.email.readonly': 'Die E-Mail kann nicht geändert werden',
                'profile.email.readonly.help': 'Die E-Mail ist eindeutig und kann nicht geändert werden',
                'profile.name': 'Vorname',
                'profile.lastname': 'Nachname',
                "profile.alias": "Alias",
                "profile.email": "E-Mail",
                'profile.phone': 'Telefon',
                'profile.language': 'Sprache',
                'profile.country': 'Land',
                'profile.country.select': 'Land auswählen',
                'profile.biography': 'Biografie',
                "bio.modal.original": "Original",
                'bio.modal.translation': 'Übersetzung',
                'bio.modal.empty': 'Dieser Kontakt hat keine Biografie.',
                'bio.modal.translating': 'Wird übersetzt...',
                'bio.modal.translation_error': 'Die Biografie konnte nicht übersetzt werden.',
                'attachment.unnamed_file': 'Datei',
                'auth.login_error.default_title': 'Zugriffsfehler',
                'auth.login_error.default_message': 'Anmeldung nicht möglich.',
                'profile.photo': 'Profilbild',
                'notifications.bell.aria': 'Benachrichtigungen',
                'notifications.panel.title': 'Benachrichtigungen',
                'notifications.empty': 'Keine Benachrichtigungen',
                'notifications.mark_read': 'Beim Öffnen als gelesen markieren',
                'profile.notifications.sound': 'Benachrichtigungston',
                'profile.notifications.sound_desc': 'Ton abspielen bei neuen Nachrichten oder wichtigen Hinweisen',
                'profile.plan.expires': 'Läuft ab am',
                'profile.plan.loading_info': 'Lade Tarifinformationen...',
                'profile.plan.valid_until': 'Gültig bis:',
                'profile.plan.active_since': 'Aktiv seit:',
                'profile.plan.active_badge': '✓ Aktiv',
                'profile.plan.upgrade.button': 'Auf PRO upgraden',
                'profile.plan.upgrade.hint': 'Zugriff auf alle Funktionen ohne Grenzen',
                'billing.change_plan': 'Plan wechseln',
                'billing.usage.title': 'Nutzung des Plans',
                'billing.usage.users': 'Benutzer',
                'billing.usage.messages': 'Nachrichten (heute)',
                'billing.usage.invitations': 'Einladungen (heute)',
                'billing.usage.messages_month': 'Nachrichten diesen Monat',
                'billing.usage.chats': 'Unterhaltungen',
                'billing.usage.warning': 'Sie nähern sich dem Limit Ihres Plans. Wechseln Sie zu PRO für mehr Kapazität.',
                'plans.limit.reached': 'Limit erreicht — Plan verbessern',
                'profile.theme.dark': 'Dunkler Modus',
                'profile.theme.light': 'Heller Modus',
                'profile.theme.argentina': 'Argentinien Thema',
                'modal.title': 'Titel',
                'modal.success.title': 'Erfolg',
                'modal.error.title': 'Fehler',
                'modal.warning.title': 'Warnung',
                "info.title": "Information",
                'appearance.title': 'Darstellung',
                'appearance.theme.light': 'Hell',
                'appearance.theme.dark': 'Dunkel',
                'theme.title': 'Design',
                'theme.light': 'Hell',
                'theme.dark': 'Dunkel',
                'profile.photo.section': 'Profilfoto',
                'profile.personalInfo': 'Persönliche Informationen',
                'profile.preferences': 'Einstellungen',
                'profile.country.help': 'Die Zeitzone wird automatisch entsprechend dem ausgewählten Land zugewiesen',
                'profile.lastname.placeholder': 'Ihr Nachname (optional)',
                'profile.name.placeholder': 'Ihr Vorname (optional)',
                'profile.biography.placeholder': 'Erzählen Sie uns von sich...',
                'profile.plan.title': 'Abonnement',
                'profile.plan.current': 'Aktueller Plan',
                'profile.plan.free.description': 'Kostenloser Plan mit Einschränkungen. Upgrade auf PRO für vollen Zugang.',
                'profile.plan.pro.description': 'Sie haben vollen Zugang zu allen Funktionen.',
                'profile.photo.change': 'Profilbild ändern',
                'message.placeholder': 'Nachricht schreiben...',
                'message.placeholderWithFile': 'Datei senden',
                'message.sent_from_country': 'Gesendet aus',
                'message.sent_at_local_time': 'Lokale Zeit des Absenders',
                'message.timezone_label': 'Zeitzone',
                'message.context_info': 'Diese Nachricht speichert den Zeitkontext des Versandzeitpunkts.',
                'message.context_pro_hint': 'Diese Nachricht enthält Sender-Zeit- und Standortkontext in Pro-Plänen.',
                'message.context_pro_badge': 'Pro-Kontext',
                'attachment.title': 'Datei anhängen',
                'attachment.close': 'Schließen',
                'attachment.gallery': 'Foto-/Videogalerie',
                'attachment.cameraFront': 'Frontkamera',
                'attachment.cameraBack': 'Rückkamera',
                'attachment.cameraWeb': 'Webkamera',
                'attachment.selectFile': 'Datei auswählen (PDF, Text, Bilder, Videos)',
                'attachment.remove': 'Entfernen',
                'attachments.recipientFreeBlocked.title': 'Planlimit',
                'attachments.recipientFreeBlocked.sender': 'Dieser Nutzer hat den Free-Tarif und kann keine Dateianhänge empfangen.',
                'attachments.recipientFreeBlocked.receiver': '{senderName} hat versucht, dir einen Anhang zu senden, aber dein {planName}-Tarif erlaubt keine Anhänge. Wir empfehlen ein höheres Paket, um Dateien zu empfangen.',
                'attachments.recipientFreeBlocked.upgradeCta': 'Plan upgraden',
                'attachment.audioNotSupported': 'Sprachnachrichten sind nicht mit ArChat® kompatibel. Bitte senden Sie eine schriftliche Nachricht.',
                'message.audioDeprecated.title': 'Sprachnachricht nicht kompatibel',
                'message.audioDeprecated.message': 'Diese Sprachnachricht ist nicht mehr mit ArChat® kompatibel. Bitte senden Sie eine schriftliche Nachricht.',
                'camera.title': 'Kamera',
                'camera.close': 'Schließen',
                'camera.switch': 'Kamera wechseln',
                'camera.capture': 'Foto aufnehmen',
                'camera.loading': 'Kamera wird gestartet...',
                'camera.retry': 'Wiederholen',
                'camera.error.access': 'Kamera konnte nicht zugegriffen werden. Berechtigungen überprüfen.',
                'camera.error.permission': 'Kameraberechtigung verweigert. Bitte erlauben Sie den Kamerazugriff in den Browsereinstellungen.',
                'camera.error.notFound': 'Keine Kamera gefunden.',
                'camera.error.busy': 'Die Kamera wird von einer anderen Anwendung verwendet.',
                'camera.error.constraint': 'Die Kameraeinschränkungen können nicht erfüllt werden.',
                'profile.photo.take': 'Foto aufnehmen',
                'profile.photo.gallery': 'Aus Galerie auswählen',
                'profile.photo.select': 'Foto auswählen',
                'profile.photo.select.gallery': 'Aus Galerie auswählen',
                'profile.photo.uploading': 'Bild wird hochgeladen...',
                'profile.photo.upload.success': 'Profilfoto erfolgreich aktualisiert',
                'profile.photo.upload.success.title': 'Foto Aktualisiert',
                'profile.photo.upload.error': 'Fehler beim Hochladen des Profilfotos. Bitte versuchen Sie es erneut.',
                'profile.photo.upload.error.title': 'Upload-Fehler',
                'user.default': 'Benutzer',
                'logout.title': 'Bestätigen',
                'logout.confirm': 'Sind Sie sicher, dass Sie sich abmelden möchten?',
                'contacts.title': 'Kontakte',
                'contacts.search': 'Kontakt suchen',
                'contacts.search.placeholder': 'Suche nach Benutzername, Name, Nachname, Land oder Sprache...',
                'contacts.sort': 'Sortieren',
                'contacts.sortByName': 'Nach Name',
                'contacts.sortByStatus': 'Nach Zustand',
                'contacts.sortByRecent': 'Neueste',
                'contacts.filter': 'Filtern',
                'contacts.filterAll': 'Alle',
                'contacts.filterAvailable': 'Verfügbar',
                'contacts.filterInvited': 'Eingeladen',
                'contacts.filterBlocked': 'Blockiert',
                'contacts.pending_invitations': 'Ausstehende Einladungen',
                'contacts.status.invitation_sent': 'Einladung gesendet',
                'contacts.empty': 'Keine Kontakte',
                'contacts.empty.title': 'Sie haben noch keine Kontakte',
                'contacts.empty.message': 'Laden Sie einen ein oder fügen Sie einen hinzu, um zu chatten.',
                'contacts.empty.invite_button': 'Kontakt einladen',
                'contacts.empty.private.message': 'Ihr Profil ist privat. Laden Sie Kontakte ein, um zu chatten.',
                'contacts.empty.private.invite_button': 'Kontakt einladen',
                'contacts.search.no_results': 'Keine Kontakte gefunden',
                'contacts.search.clear': 'Alle anzeigen',
                'contacts.controls.search_placeholder': 'Kontakt suchen...',
                'contacts.controls.search_label': 'Kontakt suchen',
                'contacts.controls.sort_label': 'Sortieren nach',
                "contacts.controls.sort.name": "Name",
                'contacts.controls.sort.status': 'Zustand',
                'contacts.controls.sort.recent': 'Neueste',
                'contacts.controls.sort.manual': 'Manuell',
                'contacts.controls.sort.manual_drag_hint': 'Zum Sortieren ziehen',
                'contacts.controls.filter_label': 'Zustand',
                'contacts.controls.filter.all': 'Alle',
                'contacts.controls.filter.available': 'Verfügbar',
                'contacts.controls.filter.invited': 'Eingeladen',
                'contacts.controls.filter.blocked': 'Blockiert',
                'contacts.controls.filter.favorites': 'Favoriten',
                'contacts.nick': 'Benutzername',
                'contacts.name': 'Vorname',
                'contacts.lastname': 'Nachname',
                'contacts.country': 'Land',
                'contacts.language': 'Sprache',
                'contacts.status': 'Zustand',
                'status.available': 'Verfügbar',
                'status.busy': 'Beschäftigt',
                'status.in_call': 'Im Gespräch',
                'status.away': 'Abwesend',
                "status.offline": "Offline",
                'status.custom': 'Benutzerdefinierte Nachricht',
                'status.set_title': 'Verfügbarkeitsstatus',
                'status.set_button': 'Zustand ändern',
                'status.placeholder': 'Optionale Nachricht (z. B. In Besprechung)',
                'contacts.status.pending_registration': 'Registrierung ausstehend',
                'contacts.status.registered': 'Eingeladen - Registriert',
                'contacts.status.ready_to_chat': 'Bereit zum Chatten',
                'contacts.status.active_conversation': 'Aktive Unterhaltung',
                'contacts.invitation.pending.title': 'Ausstehende Einladung',
                'contacts.invitation.pending.message': 'Diese Einladung wartet auf Registrierung. Der Kontakt erhält eine E-Mail zur Vervollständigung seiner Registrierung. Sobald registriert, können Sie mit ihm chatten.',
                'contacts.error.no_registered': 'Der Kontakt ist noch nicht registriert. Warten Sie, bis er seine Registrierung abgeschlossen hat.',
                'contact.edit.title': 'Kontakt bearbeiten',
                'contact.edit.alias.label': 'Benutzerdefinierter Alias',
                'contact.edit.alias.placeholder': 'Z.B: Hans von der Arbeit',
                'contact.edit.alias.help': 'Dieser Name wird anstelle des echten Namens angezeigt',
                'contact.edit.nota.label': 'Persönliche Notiz',
                'contact.edit.nota.placeholder': 'Fügen Sie eine Notiz zu diesem Kontakt hinzu...',
                'contact.edit.nota.help': 'Private Notizen nur für Sie sichtbar',
                'contact.edit.error.noUser': 'Fehler: Benutzer nicht identifiziert',
                'contact.edit.error.noContactId': 'Fehler: Kontakt konnte nicht identifiziert werden',
                'contact.edit.error.save': 'Fehler beim Speichern',
                'contact.limit.title': 'Kontaktlimit erreicht',
                'contact.limit.message': 'Der FREE-Plan erlaubt bis zu 2 Kontakte pro Nutzer. Upgrade auf FOUNDATION oder PRO für mehr Kapazität, sobald die Abrechnung aktiv ist.',
                'contact.edit.info.personalized': 'Diese Änderungen sind nur für Sie personalisiert und betreffen andere Benutzer nicht.',
                'contact.edit.profileInfo': 'Profilinformationen',
                'export.title': 'Konversation exportieren',
                'export.description': 'Wählen Sie das Format aus, in dem Sie diese Konversation exportieren möchten:',
                'export.progress': 'Exportiere...',
                "export.format.pdf": "PDF",
                'export.format.pdf.description': 'PDF-Dokument mit allen Bildern und Dateien',
                "export.format.html": "HTML",
                'export.format.html.description': 'HTML-Datei, die Sie in jedem Browser öffnen können',
                'export.info': 'Der Export enthält alle Nachrichten, Bilder und Dateien aus dieser Konversation.',
                'export.pro_required.title': 'Konversation exportieren',
                'export.pro_required.message': 'Diese Funktion ist im PRO-Tarif verfügbar.',
                'invitation.title': 'Kontakt per E-Mail einladen',
                'invitation.modal.title': 'Einladung Senden',
                'invitation.modal.description': 'Laden Sie jemanden ein, mit Ihnen auf ArChat® zu chatten. Er erhält eine E-Mail mit einem Link zur Annahme der Einladung.',
                'invitation.email.label': 'E-Mail des Eingeladenen',
                'invitation.email.placeholder': 'beispiel@email.com',
                'invitation.email.required': 'E-Mail ist erforderlich',
                'invitation.email.invalid': 'Bitte geben Sie eine gültige E-Mail ein',
                'invitation.language.label': 'Bevorzugte Sprache des Eingeladenen',
                'invitation.language.help': 'Die E-Mail wird in dieser Sprache gesendet',
                'invitation.mode.label': 'Gesprächsmodus',
                'invitation.mode.profesional': 'Professionell',
                'invitation.mode.profesional.description': 'Formelles und professionelles Gespräch',
                'invitation.mode.tecnico': 'Technisch',
                'invitation.mode.tecnico.description': 'Technisches und spezialisiertes Gespräch',
                'invitation.mode.casual': 'Lässig',
                'invitation.mode.casual.description': 'Informelles und freundliches Gespräch',
                'invitation.message.label': 'Persönliche Nachricht (optional)',
                'invitation.message.placeholder': 'Schreiben Sie eine persönliche Nachricht für den Eingeladenen...',
                'invitation.send': 'Einladung Senden',
                'invitation.sending': 'Wird gesendet...',
                'invitation.success': 'Einladung erfolgreich gesendet',
                'invitation.error': 'Fehler beim Senden der Einladung',
                'invitation.error.self': 'Sie können sich nicht selbst einladen',
                'invitation.error.duplicate': 'Eine ausstehende Einladung existiert bereits für diese E-Mail',
                'invitation.list.title': 'Gesendete Einladungen',
                'invitation.list.empty': 'Sie haben keine Einladungen gesendet',
                'invitation.list.email': 'E-Mail',
                'invitation.list.language': 'Sprache',
                'invitation.list.mode': 'Modus',
                'invitation.list.status': 'Zustand',
                'invitation.list.created': 'Gesendet',
                'invitation.list.expires': 'Läuft ab',
                'invitation.list.actions': 'Aktionen',
                'invitation.status.pending': 'Ausstehend',
                'invitation.status.accepted': 'Akzeptiert',
                'invitation.status.expired': 'Abgelaufen',
                'invitation.status.cancelled': 'Storniert',
                'invitation.copy.link': 'Link Kopieren',
                'invitation.copy.success': 'Link in die Zwischenablage kopiert',
                'invitation.cancel': 'Abbrechen',
                'invitation.cancel.confirm': 'Sind Sie sicher, dass Sie diese Einladung stornieren möchten?',
                'invitation.cancel.success': 'Einladung erfolgreich storniert',
                'invitation.cancel.title': 'Stornierung Bestätigen',
                'invitation.resend': 'E-Mail erneut senden',
                'invitation.resend.title': 'Einladung Erneut Senden',
                'invitation.resend.success': 'Einladungs-E-Mail erfolgreich erneut gesendet',
                'invitation.resend.error': 'Fehler beim erneuten Senden der Einladungs-E-Mail',
                'invitation.accept.title': 'Einladung Annehmen',
                'invitation.accept.description': 'Sie wurden eingeladen, auf ArChat® zu chatten',
                'invitation.accept.inviter': 'Eingeladen von',
                'invitation.accept.message': 'Persönliche Nachricht',
                'invitation.accept.login': 'Anmelden',
                'invitation.accept.register': 'Registrieren',
                'invitation.accept.error.invalid': 'Ungültiger Einladungstoken',
                'invitation.accept.error.expired': 'Diese Einladung ist abgelaufen',
                'invitation.accept.error.accepted': 'Diese Einladung wurde bereits angenommen',
                'invitation.accept.error.cancelled': 'Diese Einladung wurde storniert',
                'invitation.accept.error.email_mismatch': 'Ihre Kontoe-Mail stimmt nicht mit der Einladungs-E-Mail überein',
                'invitation.accept.success': 'Einladung angenommen. Weiterleitung zum Chat...',
                'invitations.sent.title': 'Gesendete Einladungen',
                'invitations.sent.empty': 'Keine ausstehenden Einladungen',
                'invitations.pending.title': 'Ausstehende Einladungen',
                'invitations.columns.email': 'E-Mail',
                'invitations.columns.language': 'Sprache',
                'invitations.columns.mode': 'Modus',
                'invitations.columns.status': 'Zustand',
                'invitations.columns.sentAt': 'Gesendet',
                'invitations.columns.actions': 'Aktionen',
                'invitations.status.pending': 'Ausstehend',
                'invitations.status.accepted': 'Angenommen',
                'invitations.status.cancelled': 'Storniert',
                'invitations.status.expired': 'Abgelaufen',
                'invitations.actions.cancel': 'Stornieren',
                'invitations.actions.copy': 'Link kopieren',
                'invitations.actions.resend': 'E-Mail erneut senden',
                'profile.privacy.title': 'Datenschutz',
                'profile.privacy.public_visibility': 'Mein Profil öffentlich sichtbar machen',
                'profile.privacy.public_warning': 'Dies ermöglicht es jedem ArChat®-Benutzer, Sie zu finden und ein Gespräch zu beginnen.',
                'profile.privacy.private_info': 'Ihr Profil ist privat. Nur Benutzer, die Sie einladen oder die Sie einladen, können mit Ihnen chatten.',
                'profile.privacy.private_default': 'Standardmäßig ist Ihr Profil privat für mehr Sicherheit.',
                'common.close': 'Schließen',
                'common.sending': 'Senden...',
                'common.cancel': 'Abbrechen',
                'common.confirm': 'Bestätigen',
                'common.save': 'Speichern',
                'common.saving': 'Speichern...',
                'buttons.accept': 'Akzeptieren',
                'buttons.cancel': 'Abbrechen',
                'buttons.save': 'Speichern',
                'buttons.edit': 'Bearbeiten',
                'buttons.retry': 'Erneut versuchen',
                'buttons.confirm': 'Bestätigen',
                'buttons.yes': 'Ja',
                'buttons.no': 'Nein',
                'buttons.send': 'Senden',
                'buttons.close': 'Schließen',
                'buttons.continue': 'Fortsetzen',
                'buttons.delete': 'Löschen',
                'buttons.logout': 'Abmelden',
                'buttons.back': 'Zurück',
                'buttons.update': 'Aktualisieren',
                'buttons.upload': 'Hochladen',
                'buttons.select': 'Auswählen',
                'conversation.backToContacts': 'Zurück zu Kontakten',
                'help.title': 'ArChat® Hilfe',
                'help.what.title': 'Was ist ArChat®?',
                'help.what.description': 'ArChat® ist ein schriftliches Messaging-System mit automatischer Übersetzung, das es Ihnen ermöglicht, mit Menschen zu kommunizieren, die Ihre Sprache nicht sprechen, und dabei Klarheit, Kontext und Privatsphäre ab der ersten Nachricht zu bewahren.',
                'help.how.title': 'Wie funktioniert es?',
                'help.how.step1.title': 'Anmelden',
                'help.how.step1.description': 'Verwenden Sie Ihren Nick und Ihr Passwort, um auf das System zuzugreifen. Wenn Sie kein Konto haben, wird es automatisch erstellt.',
                'help.how.step2.title': 'Laden Sie Ihren Kontakt ein',
                'help.how.step2.description': 'Laden Sie Ihren Kontakt per E-Mail von Ihrem Profil ein. Definieren Sie die Sprache und den Gesprächsmodus von Anfang an.',
                'help.how.step3.title': 'Schreiben Sie in Ihrer Sprache',
                'help.how.step3.description': 'Schreiben Sie Ihre Nachricht in Ihrer bevorzugten Sprache. Das System übersetzt die geschriebene Nachricht automatisch.',
                'help.how.step4.title': 'Der andere erhält übersetzt',
                'help.how.step4.description': 'Der Empfänger erhält die Nachricht automatisch in seine Sprache übersetzt, wobei Klarheit und Kontext erhalten bleiben.',
                'help.features.title': 'Hauptfunktionen',
                'help.features.translation': '🌐 Automatische und sofortige Übersetzung zwischen Sprachen',
                'help.features.status': '💬 Anwesenheitsstatus (Online, Inaktiv, Nicht stören, etc.)',
                'help.features.statusCustom': '💬 Benutzerdefinierte Status mit Emoji und personalisierter Nachricht',
                'help.features.contacts': '👥 Vollständige Kontaktliste mit Suche und Filtern',
                'help.features.contactsMobile': '📱 Optimierte mobile Ansicht mit vollständigen Informationen (Nachname, Land, Status)',
                'help.features.contactsFilter': '👁️ Schaltfläche zum Anzeigen/Ausblenden von Nicht-Favoriten-Kontakten - reduziert die Liste auf nur Ihre Favoriten',
                'help.features.contactAlias': '✏️ Benutzerdefinierter Alias und private Notizen für jeden Kontakt - klicken Sie auf den Kontaktnamen in der Unterhaltung',
                'help.features.themes': '🎨 Zwei verfügbare Themen: Argentinien (hellblau/weiß/gold) und Dunkel (tiefes Lila)',
                'help.features.messages': '📨 Echtzeit-Messaging mit Lesebestätigungen',
                'help.features.attachments': '📎 Dateien anhängen, die mit schriftlicher Kommunikation kompatibel sind: Bilder, Videos und PDF-Dokumente',
                'help.features.camera': '📸 Fotoaufnahme mit Front-, Rückkamera oder Webcam',
                'help.features.gallery': '🖼️ Dateiauswahl aus der Galerie',
                'help.features.compression': '🗜️ Automatische Bildkomprimierung und Thumbnail-Generierung',
                'help.features.progress': '📊 Fortschrittsbalken während des Datei-Uploads',
                'help.features.delete': '🗑️ Löschen Ihrer eigenen Nachrichten',
                'help.features.scroll': '⬇️ Automatisches Scrollen zur letzten Nachricht beim Öffnen der Unterhaltung',
                'help.features.profile': '👤 Anpassbares Profil mit Avatar, Biografie und Präferenzen',
                'help.features.profileEdit': '✏️ Profilbearbeitung ohne Unterbrechungen (keine Aktualisierung während der Bearbeitung)',
                'help.features.countries': '🌍 Vollständige Liste von 195+ Ländern mit automatischer Zeitzonenauswahl',
                'help.features.registration': '📧 Registrierung mit E-Mail-Bestätigung und Sicherheits-CAPTCHA',
                'help.features.multilanguage': '🗣️ Unterstützung für mehrere Sprachen (Spanisch, Englisch, Portugiesisch, Französisch, Deutsch, Italienisch, Russisch, Chinesisch, Japanisch, Koreanisch, Arabisch, Hindi)',
                'help.features.pwa': '📲 Installierbare PWA-Anwendung auf mobilen Geräten und Desktop',
                'help.features.sync': '🔄 Automatische Synchronisierung von Nachrichten alle 5 Sekunden',
                'help.features.deleteSync': '🗑️ Automatische Synchronisierung gelöschter Nachrichten zwischen Geräten',
                'help.features.notifications': '🔔 Tonbenachrichtigungen für neu empfangene Nachrichten',
                'help.features.retranslation': '🔄 Automatische Neuübersetzung von Nachrichten, wenn der erste Versuch fehlschlägt',
                'help.features.preview': '👁️ Dateivorschau vor dem Senden',
                'help.features.security': '🔒 Sicherheitssystem mit CAPTCHA, Browser-Fingerabdruck und Ratenbegrenzung',
                'help.features.passwordRecovery': '🔑 Passwort-Wiederherstellung per E-Mail',
                'help.features.emailConfirmation': '📧 Kontobestätigung per E-Mail mit Aktivierungslink',
                'help.features.invitations': '📧 Private E-Mail-Einladungen - Laden Sie externe Kontakte mit definierter Sprache und Kontext ein',
                'help.features.invitationsManagement': '📋 Vollständige Einladungsverwaltung - Listen, erneut senden oder stornieren Sie ausstehende Einladungen aus dem Menü',
                'help.features.contactStatus': '🏷️ Sichtbarer Kontaktstatus - Sehen Sie den Status jedes Kontakts (ausstehend, registriert, bereit zum Chatten)',
                'help.features.favorites': '⭐ Favoriten-System - Markieren Sie Kontakte als Favoriten für schnellen Zugriff',
                'help.features.profilePhoto': '📸 Verbesserter Profilfoto-Upload - Wählen Sie Bilder aus der Galerie mit sofortiger Vorschau',
                'help.features.translationSender': '👁️ Übersetzungsansicht für Absender - Sehen Sie, wie Ihre Nachricht in die Sprache des Empfängers übersetzt wurde',
                'help.features.unifiedContacts': '🔗 Einheitliches Kontaktmodell - Kontakte werden aus Einladungen und bestehenden Konversationen abgeleitet',
                'help.features.privacy': '🔒 Privater Modus standardmäßig - Ihr Profil ist privat und nur über direkte Einladung zugänglich',
                'help.features.export': '💾 Konversationsexport - Exportieren Sie vollständige Konversationen in PDF oder HTML mit Bildern und Dateien',
                'help.tips.title': 'Nützliche Tipps',
                'help.tips.language': '✅ Legen Sie Ihre bevorzugte Sprache in Ihrem Profil fest, um korrekt übersetzte Nachrichten zu erhalten',
                'help.tips.status': '✅ Aktualisieren Sie Ihren Anwesenheitsstatus, damit andere Ihre Verfügbarkeit kennen',
                'help.tips.statusCustom': '✅ Erstellen Sie benutzerdefinierte Status mit Emoji und Nachricht, um Ihren aktuellen Zustand auszudrücken',
                'help.tips.search': '✅ Markieren Sie Favoriten (Stern) und blockieren Sie Benutzer über das Modal "Benutzer"',
                'help.tips.contactsFilter': '✅ Verwenden Sie die Augenschaltfläche (👁️) in der oberen Leiste, um Kontakte anzuzeigen oder auszublenden, die keine Favoriten sind',
                'help.tips.contactAlias': '✅ Klicken Sie auf den Kontaktnamen in der Unterhaltung, um einen benutzerdefinierten Alias und private Notizen hinzuzufügen',
                'help.tips.avatar': '✅ Klicken Sie auf den Avatar eines Kontakts, um sein Bild in großer Größe zu sehen',
                'help.tips.messages': '✅ Das ArChat®-Symbol blinkt, wenn Sie ungelesene Nachrichten haben',
                'help.tips.attachments': '✅ Hängen Sie Bilder, Videos, Audio oder PDFs mit der Klammer-Taste (📎) an',
                'help.tips.camera': '✅ Verwenden Sie die Kamera, um Fotos direkt aus der App aufzunehmen',
                'help.tips.compression': '✅ Bilder werden automatisch komprimiert, um Speicherplatz zu sparen',
                'help.tips.delete': '✅ Sie können Ihre eigenen Nachrichten löschen, indem Sie auf die Löschen-Taste klicken',
                'help.tips.profile': '✅ Bearbeiten Sie Ihr Profil ohne Sorge: Das System aktualisiert sich nicht, während Sie bearbeiten',
                'help.tips.themes': '✅ Ändern Sie das Thema unter Einstellungen > Darstellung: Argentinien (hellblau) oder Dunkel (tiefes Lila)',
                'help.tips.country': '✅ Wählen Sie Ihr Land im Profil aus, damit die Zeitzone automatisch konfiguriert wird',
                'help.tips.registration': '✅ Bei der Registrierung bestätigen Sie Ihre E-Mail, um Ihr Konto vollständig zu aktivieren',
                'help.tips.writing': '✅ Schreiben Sie klare Nachrichten: ArChat® übersetzt die Bedeutung des geschriebenen Textes und behält Kontext und Klarheit bei',
                'help.tips.install': '✅ Installieren Sie ArChat® als PWA-Anwendung auf Ihrem Gerät für schnellen Zugriff vom Desktop',
                'help.tips.sync': '✅ Nachrichten werden automatisch alle 5 Sekunden synchronisiert - Sie müssen nicht aktualisieren',
                'help.tips.deleteSync': '✅ Wenn Sie eine Nachricht löschen, wird sie automatisch auf allen Geräten des Empfängers gelöscht',
                'help.tips.notifications': '✅ Sie hören einen Ton, wenn Sie eine neue Nachricht von einem anderen Benutzer erhalten',
                'help.tips.retranslation': '✅ Wenn eine Nachricht nicht korrekt übersetzt wurde, versucht das System, sie automatisch neu zu übersetzen',
                'help.tips.preview': '✅ Überprüfen Sie die Dateivorschau vor dem Senden, um sicherzustellen, dass es die richtige ist',
                'help.tips.passwordRecovery': '✅ Wenn Sie Ihr Passwort vergessen haben, verwenden Sie den Link "Passwort vergessen?" beim Login',
                'help.tips.emailConfirmation': '✅ Überprüfen Sie Ihre E-Mail nach der Registrierung und klicken Sie auf den Bestätigungslink',
                'help.tips.languageChange': '✅ Ändern Sie Ihre Sprache jederzeit im Flaggen-Auswahlfeld - aktualisiert sich sofort',
                'help.tips.inputFixed': '✅ Auf dem PC bleibt die Schreibleiste am unteren Bildschirmrand fixiert für mehr Komfort',
                'help.tips.invitations': '✅ Laden Sie Kontakte per E-Mail von Ihrem Profil ein - Definieren Sie Sprache und Gesprächsmodus von Anfang an',
                'help.tips.invitationsManagement': '✅ Verwalten Sie Ihre Einladungen aus dem Menü "Gesendete Einladungen" - Senden Sie E-Mails erneut oder stornieren Sie ausstehende Einladungen',
                'help.tips.contactStatus': '✅ Beobachten Sie den Status jedes Kontakts in der Liste - Ausstehend (orange), Registriert (grün) oder Aktive Konversation (blau)',
                'help.tips.favorites': '✅ Markieren Sie Kontakte als Favoriten mit dem Stern ⭐ - Favoriten erscheinen zuerst in Ihrer Liste',
                'help.tips.profilePhoto': '✅ Laden Sie Ihr Profilfoto von "Aus Galerie wählen" hoch - Sie sehen eine Vorschau vor dem Speichern',
                'help.tips.translationSender': '✅ Beim Senden einer Nachricht erweitern Sie das Übersetzungspanel, um zu sehen, wie sie in die Sprache des Empfängers übersetzt wurde',
                'help.tips.unifiedContacts': '✅ Ihre Kontakte werden automatisch angezeigt, wenn sie Einladungen annehmen oder Sie Konversationen mit ihnen haben',
                'help.tips.privacy': '✅ Ihr Profil ist standardmäßig privat - Aktivieren Sie die öffentliche Sichtbarkeit in Profil > Datenschutz, wenn Sie möchten, dass andere Sie finden',
                'help.tips.export': '✅ Exportieren Sie vollständige Konversationen mit der Schaltfläche ⬇️ in der Kopfzeile - Wählen Sie PDF oder HTML mit allen Bildern',
                "help.support.title": "Medium",
                'help.support.description': 'Wenn Sie Probleme oder Fragen haben, wenden Sie sich an den Systemadministrator oder überprüfen Sie die verfügbare technische Dokumentation.',
                'help.about.title': 'Über',
                'help.about.developer': 'Entwickelt von:',
                'help.about.location': 'MDQ - ARGENTINIEN',
                'help.about.linkedin': 'LinkedIn-Profil anzeigen',
                'presence.title': 'Anwesenheitsstatus',
                'presence.currentStatus': 'Aktueller Zustand:',
                'presence.changeStatus': 'Zustand ändern',
                "presence.status.online": "Online",
                'presence.status.online.title': 'Online - Für alle sichtbar',
                'presence.status.online.description': 'Online: Für alle Kontakte sichtbar',
                'presence.status.idle': 'Inaktiv',
                'presence.status.idle.title': 'Inaktiv - Zeigt vorübergehende Abwesenheit an',
                'presence.status.idle.description': 'Inaktiv: Zeigt an, dass Sie vorübergehend nicht verfügbar sind',
                'presence.status.dnd': 'Nicht stören',
                'presence.status.dnd.title': 'Nicht stören - Zeigt an, dass Sie nicht unterbrochen werden möchten',
                'presence.status.dnd.description': 'Nicht stören: Sichtbares Signal, dass Sie nicht unterbrochen werden möchten',
                'presence.status.busy': 'Beschäftigt',
                'presence.status.busy.title': 'Beschäftigt - Nicht verfügbar',
                'presence.status.busy.description': 'Beschäftigt: Nicht verfügbar',
                "presence.status.offline": "Offline",
                'presence.status.offline.title': 'Getrennt - Als offline erscheinen',
                'presence.status.offline.description': 'Offline: Als getrennt erscheinen',
                'presence.status.custom': 'Benutzerdefiniert',
                'presence.status.custom.title': 'Benutzerdefiniert - Eindeutiger Status mit Emoji',
                'presence.status.custom.description': 'Benutzerdefiniert: Eindeutiger Status mit Emoji und optionalem Ablaufdatum',
                "dashboard.title": "Armaturenbrett",
                'dashboard.planUsage': 'Plannutzung',
                'dashboard.filesSummary': 'Meine Dateien',
                'dashboard.promotions': 'Aktionen',
                'dashboard.sessions': 'Aktive Sitzungen',
                'dashboard.explore': 'Entdecken',
                'dashboard.noSessions': 'Keine aktiven Sitzungen',
                'dashboard.welcomeTitle': 'Willkommen bei ArChat®',
                'dashboard.welcomeSubtitle': 'Kommunizieren Sie in jeder Sprache.',
                'dashboard.stepInvite': 'Schritt 1: ersten Kontakt einladen',
                'dashboard.stepMessage': 'Schritt 2: erste Nachricht senden',
                'dashboard.inviteContact': 'Kontakt einladen',
                'dashboard.exploreArChat': 'ArChat entdecken',
                'dashboard.promotionsTitle': 'Aktionen',
                'dashboard.promotionsText': 'Überblick Empfehlungs- und Prämienprogramm.',
                'dashboard.viewPromotions': 'Aktionen ansehen',
                'dashboard.usageTitle': 'Plannutzung',
                'dashboard.sessionsTitle': 'Aktive Sitzungen',
                'dashboard.sessionsEmpty': 'Keine aktiven Sitzungen',
                'dashboard.filesTitle': 'Meine Dateien',
                'dashboard.viewFiles': 'Dateien anzeigen',
                'dashboard.noBlocks': 'Keine aktiven Kacheln. Mindestens eine in den Einstellungen aktivieren.',
                'dashboard.openSettings': 'Einstellungen öffnen',
                'dashboard.goToContacts': 'Zu Kontakten',
                'dashboard.filesVisible': 'Sichtbare Dateien',
                'dashboard.filesSampleNote': 'Zählung aus der ersten Seite (bis 500+).',
                'dashboard.loading': 'Daten werden geladen...',
                'dashboard.error.title': 'Fehler',
                'dashboard.error.load': 'Nutzungsdaten konnten nicht geladen werden',
                'dashboard.error.generic': 'Fehler beim Laden des Dashboards',
                'dashboard.error.no_data': 'Daten konnten nicht geladen werden',
                'dashboard.retry': 'Wiederholen',
                'dashboard.unlimited': 'Unbegrenzt',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                'dashboard.card.contacts': 'Kontakte',
                'dashboard.card.chars': 'Zeichen',
                'dashboard.card.chars_month': 'Zeichen diesen Monat',
                'dashboard.card.storage': 'Speicher',
                'dashboard.card.devices': 'Aktive Geräte',
                'dashboard.upgrade.title': 'Benötigen Sie mehr Ressourcen?',
                'dashboard.upgrade.message': 'Upgraden Sie Ihren Plan für mehr Kontakte, Zeichen, Speicher und aktive Geräte.',
                'dashboard.upgrade.button': 'Plan upgraden',
                'upgrade.title': 'Plan upgraden',
                'upgrade.close': 'Schließen',
                'upgrade.cancel': 'Abbrechen',
                'upgrade.activate': 'PRO-Plan aktivieren',
                'upgrade.activating': 'Aktivierung...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': 'Planvergleich',
                'upgrade.free.label': 'Kostenloser Plan',
                'upgrade.free.limits.contacts': '2 Kontakte maximal',
                'upgrade.free.limits.conversations': '2 Unterhaltungen maximal',
                'upgrade.free.limits.no_export': 'Kein Datenexport',
                'upgrade.free.limits.no_advanced': 'Keine erweiterten Funktionen',
                'upgrade.pro.label': 'Pro-Plan',
                'upgrade.pro.recommended': 'EMPFOHLEN',
                'upgrade.pro.benefits.contacts': 'Unbegrenzte Kontakte',
                'upgrade.pro.benefits.contacts.desc': 'Fügen Sie alle Kontakte hinzu, die Sie benötigen, ohne Einschränkungen',
                'upgrade.pro.benefits.conversations': 'Unbegrenzte Unterhaltungen',
                'upgrade.pro.benefits.conversations.desc': 'Behalten Sie alle aktiven Unterhaltungen, die Sie benötigen',
                'upgrade.pro.benefits.export': 'Export von Unterhaltungen',
                'upgrade.pro.benefits.export.desc': 'Exportieren Sie Ihre Unterhaltungen in mehreren Formaten (PDF, TXT, JSON)',
                'upgrade.pro.benefits.notifications': 'Erweiterte Benachrichtigungen',
                'upgrade.pro.benefits.notifications.desc': 'Personalisierte Benachrichtigungen und erweiterte Konfiguration',
                'upgrade.pro.benefits.translation': 'Unbegrenzte automatische Übersetzung',
                'upgrade.pro.benefits.translation.desc': 'Übersetzen Sie Nachrichten ohne Nutzungsbeschränkungen',
                'upgrade.pro.benefits.files': 'Unbegrenzter Dateiversand',
                'upgrade.pro.benefits.files.desc': 'Teilen Sie Dateien beliebiger Größe ohne Einschränkungen',
                'upgrade.pro.benefits.themes': 'Personalisierte Themen',
                'upgrade.pro.benefits.themes.desc': 'Zugriff auf alle Themen und erweiterte Anpassung',
                'upgrade.pro.benefits.security': 'Erweiterte Sicherheit',
                'upgrade.pro.benefits.security.desc': 'Zusätzlicher Schutz und verbesserte Datenschutzfunktionen',
                'upgrade.pro.benefits.analytics': 'Statistiken und Analysen',
                'upgrade.pro.benefits.analytics.desc': 'Zugriff auf detaillierte Statistiken Ihrer Aktivität',
                'upgrade.pro.benefits.priority': 'Prioritätssupport',
                'upgrade.pro.benefits.priority.desc': 'Prioritätsbetreuung und schnelle Antwort auf Ihre Anfragen',
                'upgrade.enterprise.label': 'Enterprise-Plan',
                'upgrade.enterprise.benefits.contacts': 'Unbegrenzte Kontakte',
                'upgrade.enterprise.benefits.support': 'Prioritätssupport 24/7',
                'upgrade.enterprise.benefits.custom': 'Maßgeschneiderte Lösungen',
                'upgrade.enterprise.benefits.advanced': 'Erweiterte Unternehmensfunktionen',
                'upgrade.enterprise.benefits.integration': 'Maßgeschneiderte Integrationen',
                'upgrade.enterprise.benefits.dedicated': 'Dedizierter Support',
                'upgrade.success.title': 'PRO-Plan aktiviert',
                'upgrade.success.message': 'Ihr Plan wurde auf PRO aktualisiert. Genießen Sie alle unbegrenzten Funktionen.',
                'upgrade.error.title': 'Fehler beim Aktivieren von PRO',
                'upgrade.error.message': 'Plan konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
                'upgrade.error.generic': 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
                'upgrade.benefits.contacts': 'Unbegrenzte Kontakte',
                'upgrade.benefits.contacts.desc': 'Fügen Sie alle Kontakte hinzu, die Sie benötigen, ohne Einschränkungen',
                'upgrade.benefits.conversations': 'Unbegrenzte Unterhaltungen',
                'upgrade.benefits.conversations.desc': 'Behalten Sie alle aktiven Unterhaltungen, die Sie benötigen',
                'upgrade.benefits.export': 'Export von Unterhaltungen',
                'upgrade.benefits.export.desc': 'Exportieren Sie Ihre Unterhaltungen in mehreren Formaten (PDF, TXT, JSON)',
                'upgrade.benefits.notifications': 'Erweiterte Benachrichtigungen',
                'upgrade.benefits.notifications.desc': 'Personalisierte Benachrichtigungen und erweiterte Konfiguration',
                'upgrade.benefits.translation': 'Unbegrenzte automatische Übersetzung',
                'upgrade.benefits.translation.desc': 'Übersetzen Sie Nachrichten ohne Nutzungsbeschränkungen',
                'upgrade.benefits.files': 'Unbegrenzter Dateiversand',
                'upgrade.benefits.files.desc': 'Teilen Sie Dateien beliebiger Größe ohne Einschränkungen',
                'upgrade.benefits.themes': 'Personalisierte Themen',
                'upgrade.benefits.themes.desc': 'Zugriff auf alle Themen und erweiterte Anpassung',
                'upgrade.benefits.security': 'Erweiterte Sicherheit',
                'upgrade.benefits.security.desc': 'Zusätzlicher Schutz und verbesserte Datenschutzfunktionen',
                'upgrade.benefits.analytics': 'Statistiken und Analysen',
                'upgrade.benefits.analytics.desc': 'Zugriff auf detaillierte Statistiken Ihrer Aktivität',
                'upgrade.benefits.priority': 'Prioritätssupport',
                'upgrade.benefits.priority.desc': 'Prioritätsbetreuung und schnelle Antwort auf Ihre Anfragen',
                'upgrade.limits.contacts': '2 Kontakte maximal',
                'upgrade.limits.conversations': '2 Unterhaltungen maximal',
                'upgrade.limits.no_export': 'Kein Datenexport',
                'upgrade.limits.no_advanced': 'Keine erweiterten Funktionen',
                // API Error Messages
                'api.error.image_processing_not_available': 'Bildverarbeitung ist auf dem Server nicht verfügbar',
                'api.error.image_functions_not_available': 'Bildverarbeitungsfunktionen nicht verfügbar',
                'api.error.method_not_allowed': 'Methode nicht erlaubt',
                'api.error.user_not_identified': 'Benutzer nicht identifiziert',
                'api.error.upload_file_too_large_php': 'Die Datei überschreitet die von PHP erlaubte maximale Größe',
                'api.error.upload_file_too_large_form': 'Die Datei überschreitet die vom Formular erlaubte maximale Größe',
                'api.error.upload_file_partial': 'Die Datei wurde teilweise hochgeladen',
                'api.error.upload_no_file': 'Keine Datei wurde hochgeladen',
                'api.error.upload_no_temp_dir': 'Temporäres Verzeichnis fehlt',
                'api.error.upload_cant_write': 'Fehler beim Schreiben der Datei auf die Festplatte',
                'api.error.upload_extension_stopped': 'Eine PHP-Erweiterung hat den Upload gestoppt',
                'api.error.upload_generic': 'Datei-Upload-Fehler',
                'api.error.file_type_not_allowed': 'Dateityp nicht erlaubt. Nur Bilder sind erlaubt (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': 'Die Datei ist zu groß (max 10MB)',
                'api.error.storage_limit_exceeded': 'Speicherlimit überschritten. Aktualisieren Sie Ihren Plan, um mehr Dateien hochzuladen.',
                'api.error.user_not_found': 'Benutzer nicht gefunden oder inaktiv',
                'api.error.image_directory_access': 'Fehler beim Zugriff auf das Bildverzeichnis',
                'api.error.file_extension_not_allowed': 'Dateierweiterung nicht erlaubt',
                'api.error.temp_file_save': 'Fehler beim Speichern der temporären Datei',
                'api.error.image_processing': 'Fehler bei der Bildverarbeitung',
                'api.error.database_update': 'Fehler beim Aktualisieren der Datenbank',
                'api.error.internal_server_error': 'Interner Serverfehler',
                'api.error.internal_server_error_debug': 'Interner Serverfehler',
                'api.error.user_id_required': 'Benutzer-ID erforderlich',
                'api.error.profile_not_found': 'Profil nicht gefunden',
                'api.error.profile_load_failed': 'Fehler beim Laden des Profils',
                'api.error.invalid_data': 'Ungültige Daten',
                'api.error.validation_errors': 'Validierungsfehler',
                'api.error.profile_update_failed': 'Profil konnte nicht aktualisiert werden',
                'api.error.profile_update_error': 'Fehler beim Aktualisieren des Profils',
                // API Success Messages
                'api.success.photo_updated': 'Foto aktualisiert',
                'api.success.profile_loaded': 'Profil erfolgreich geladen',
                'api.success.profile_updated': 'Profil erfolgreich aktualisiert',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'Gerätelimit erreicht',
                'errors.deviceLimit.solution': 'Um fortzufahren, melden Sie sich von anderen Geräten ab oder verbessern Sie Ihren Plan.',
                // Error Messages - Network
                'errors.network.title': 'Verbindungsfehler',
                'errors.network.message': 'Verbindung zum Server konnte nicht hergestellt werden. Überprüfen Sie Ihre Internetverbindung.',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'Serverfehler',
                'errors.server.invalidResponse.message': 'Der Server hat eine ungültige Antwort zurückgegeben. Bitte versuchen Sie es erneut.',
                // Error Messages - Generic
                'errors.generic.title': 'Fehler',
                'errors.generic.message': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
                'errors.generic.403.title': 'Zugriffsfehler',
                'errors.generic.403.message': 'Sie haben keine Berechtigung, diese Aktion auszuführen.',
                'errors.saas_max_users': 'Benutzerlimit des Plans erreicht ({current}/{limit}).',
                'errors.tenant_frozen': 'Der Mandant ist vorübergehend gesperrt.',
                'errors.auth_invalid_credentials': 'Falscher Benutzername oder Passwort.',
                'errors.unexpected_error': 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
                'errors.accountInactive.title': 'Das Konto ist inaktiv. Geben Sie Ihre E-Mail ein, um es zu reaktivieren.',
                'errors.accountInactive.activate': 'Jetzt aktivieren',
                'errors.accountInactive.accept': 'Akzeptieren',
                'errors.accountInactive.success': 'Konto reaktiviert. Sie können sich jetzt anmelden.',
                'errors.accountInactive.fail': 'Konto konnte nicht reaktiviert werden. Bitte versuchen Sie es erneut.',
                'errors.accountInactive.completeSuccess': 'Konto mit Ihrer E-Mail aktiviert. Sie können sich jetzt anmelden.',
                'errors.accountInactive.completeFail': 'Aktivierung konnte nicht abgeschlossen werden. E-Mail prüfen und erneut versuchen.',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'Planlimit erreicht',
                'plan.errors.deviceLimit.message': 'Ihr aktueller Plan hat ein Limit für die Anzahl der gleichzeitig verbundenen Geräte.',
                'plan.errors.deviceLimit.solution': 'Um fortzufahren, melden Sie sich von anderen Geräten ab oder verbessern Sie Ihren Plan auf PRO.',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': 'Kontaktlimit erreicht',
                'plan.errors.contactsLimit.message': 'Ihr aktueller Plan hat ein Limit für die Anzahl der Kontakte, die Sie haben können.',
                'plan.errors.contactsLimit.solution': 'Um mehr Kontakte hinzuzufügen, verbessern Sie Ihren Plan auf PRO.',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': 'Einladungslimit erreicht',
                'plan.errors.invitationsLimit.message': 'Ihr aktueller Plan hat ein Limit für die Anzahl der Einladungen, die Sie pro Tag senden können.',
                'plan.errors.invitationsLimit.solution': 'Um mehr Einladungen zu senden, verbessern Sie Ihren Plan auf PRO.',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'Nachrichtenlimit erreicht',
                'plan.errors.messagesLimit.message': 'Ihr aktueller Plan hat ein Limit für die Anzahl der Nachrichten, die Sie pro Tag senden können.',
                'plan.errors.messagesLimit.solution': 'Um mehr Nachrichten zu senden, verbessern Sie Ihren Plan auf PRO.',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'Speicherlimit erreicht',
                'plan.errors.storageLimit.message': 'Ihr aktueller Plan hat ein Limit für die verfügbare Speichermenge.',
                'plan.errors.storageLimit.solution': 'Um mehr Speicher zu erhalten, verbessern Sie Ihren Plan auf PRO.',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'Plan-Upgrade erforderlich',
                'plan.errors.upgradeRequired.message': 'Diese Funktion erfordert einen höheren Plan als Ihren aktuellen.',
                'plan.errors.upgradeRequired.solution': 'Verbessern Sie Ihren Plan auf PRO, um auf diese Funktion zuzugreifen.',
                "appearance.theme.system": "System",
                "appearance.theme.corporate": "Unternehmen",
                "theme.system": "System",
                "theme.corporate": "Unternehmen",
                "founder.title": "STIFTUNG (Gründer)",
                'founder.subtitle': 'Sie unterstützen das Projekt von Anfang an mit einem Lebenszeitpreis.',
                'founder.whatIs': 'Die ersten 150 Nutzer erhalten den FOUNDATION-Plan zum reduzierten Lebenszeitpreis.',
                'founder.howItWorks': 'Ihre Founder-Stufe hängt von Ihrer Position (1 bis 150) ab.',
                'founder.benefitsTitle': 'Vorteile',
                'founder.benefitPrice': '$15 / Monat (Founder-Tarif)',
                'founder.benefitFeatures': 'Enthält alle PRO-Plan-Funktionen.',
                'founder.limit': 'Es gibt nur 150 Founder-Plätze.',
                'founder.cancelRule': 'Bei Kündigung verlieren Sie den Founder-Status, solange Sie abgemeldet sind.',
                'founder.rejoinRule': 'Wenn wieder ein Platz frei wird, können Sie reaktivieren und automatisch wieder Founder werden.',
                'founder.tiers.title': 'Founder-Stufen',
                "founder.tiers.legendary.name": "LEGENDÄRER Gründer",
                "founder.tiers.legendary.range": "Position 1–25",
                'founder.tiers.legendary.desc': 'Die Ersten, die das Projekt unterstützen. Höchste historische Priorität.',
                "founder.tiers.early.name": "Früher Gründer",
                "founder.tiers.early.range": "Platz 26–75",
                'founder.tiers.early.desc': 'Frühe Unterstützung mit besonderer Anerkennung.',
                "founder.tiers.founder.name": "Gründer",
                "founder.tiers.founder.range": "Position 76–150",
                'founder.tiers.founder.desc': 'Founder-Platz innerhalb der 150 Plätze.',
                'founder.whatIsLink': 'Was ist Founder?',
                'founder.viewTiers': 'Founder-Stufen anzeigen',
                'founder.modalClose': 'Schließen',
                'founder.activeCountLabel': 'Aktive Founders',
                'founder.urgency.lastSlots': 'Letzte Founder-Plätze verfügbar',
                "founder.positionLabel": "Gründer #{Position} / {Limit}",
                "founder.leaderboard.title": "Top-Gründer",
                "login.email.placeholder": "Ingresa tu email para confirmar tu cuenta",
                "login.email.help": "Ein Bestätigungslink wird an Ihre E-Mail gesendet",
                "auth.user_not_found": "Benutzer nicht gefunden.",
                "auth.user_inactive": "Ihr Konto ist deaktiviert. Kontaktieren Sie den Administrator.",
                "auth.tenant_mismatch": "Ihr Konto gehört nicht in diese Umgebung. Kontaktieren Sie den Administrator.",
                "auth.captcha_required": "Sie müssen die Sicherheitsüberprüfung (CAPTCHA) abschließen.",
                "mail.send_failed": "Die Wiederherstellungs-E-Mail konnte nicht gesendet werden. Überprüfen Sie Ihre SMTP-Einstellungen oder versuchen Sie es später noch einmal.",
                "auth.resend_activation": "Aktivierungs-E-Mail erneut senden",
                "register.creatingAccount": "Erstellen Sie Ihr Konto…",
                "common.edit": "Bearbeiten",
                "common.on": "Aktiviert",
                "common.off": "Deaktiviert",
                "common.refresh": "Aktualisieren",
                "system.processing": "Verarbeitung...",
                "captcha.incorrect": "Die Captcha-Antwort ist falsch.",
                "captcha.placeholder": "Schreiben Sie die Antwort",
                "captcha.questionFormat": "Was ist {a} + {b}?",
                'menu.admin': 'Verwaltung',
                "navbar.open_guide": "Führung",
                "invitation.quick_button": "Kontakt einladen",
                "onboarding.title": "Willkommen bei ArChat®",
                "onboarding.subtitle": "Kommunizieren Sie mit jedem in jeder Sprache.",
                "onboarding.step1.label": "Schritt 1",
                "onboarding.step1.text": "Laden Sie Ihren ersten Kontakt ein",
                "onboarding.step2.label": "Schritt 2",
                "onboarding.step2.text": "Senden Sie Ihre erste Nachricht",
                "onboarding.actions.invite": "Kontakt einladen",
                "onboarding.actions.explore": "Entdecken Sie ArChat®",
                'suggestions.sendSuccess': 'Ihr Vorschlag wurde erfolgreich gesendet.',
                'suggestions.sendError': 'Der Vorschlag konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
                'suggestions.sent': 'Vorschlag erfolgreich gesendet.',
                'errors.suggestionSend': 'Der Vorschlag konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
                'app.install': 'ArChat installieren',
                'menu.open': 'Menü',
                "contacts.controls.hide_non_favorites": "Nicht zu den Favoriten gehörende Kontakte ausblenden",
                "contacts.controls.show_all": "Alle Kontakte anzeigen",
                "common.navigation": "Navigation",
                "common.favorite": "Favorit",
                "common.block": "Block",
                "common.user": "Benutzer",
                "message.new": "neue Nachricht",
                "message.edit": "Nachricht bearbeiten",
                "message.edit.save": "Bearbeitung speichern",
                "message.edit.cancel": "Bearbeitung abbrechen",
                'message.translating': 'Wird übersetzt...',
                'message.translation_failed': 'Übersetzung fehlgeschlagen',
                'message.not_translated': 'Originaltext',
                'message.retry_send': 'Erneut versuchen',
                'message.retrying': 'Wird erneut versucht...',
                "message.delete": "Nachricht löschen",
                'message.deleted_placeholder': 'Nachricht gelöscht',
                "message.edited": "Bearbeitet",
                "message.edited_at": "Bearbeitet am",
                'message.delete_for_me.tooltip': 'Für mich löschen',
                'message.delete_for_me.aria': 'Diese Nachricht nur für mich löschen',
                'message.delete_for_me.confirm_title': 'Nachricht löschen',
                'message.delete_for_me.confirm_message': 'Diese Nachricht wird nur in deiner Ansicht gelöscht.',
                'message.delete_for_everyone.tooltip': 'Für alle löschen',
                'message.delete_for_everyone.aria': 'Diese Nachricht für alle Teilnehmenden löschen',
                'message.delete_for_everyone.confirm_title': 'Nachricht für alle löschen',
                'message.delete_for_everyone.confirm_message': 'Diese Nachricht wird für dich und die andere Person gelöscht.',
                'message.delete_for_everyone.window_expired': 'Löschfrist abgelaufen',
                "message.translation.show": "Siehe Original und Übersetzung",
                "message.translation.hide": "Übersetzung ausblenden",
                "emoji.search": "Emoji suchen",
                "emoji.close": "Selektor schließen",
                "captcha.refresh": "CAPTCHA neu generieren",
                'presence.unavailable': 'Status sind nicht verfuegbar',
                'presence.maintenance': 'Server befindet sich in Wartung',
                "home.access_nav": "Zugriff auf die Anwendung",
                "common.requiredFields": "Füllen Sie alle erforderlichen Felder aus.",
                "bio.view": "Siehe Biografie",
                "profile.invitations.title": "Einladungen",
                "profile.invitations.validated": "Validierte Einladungen",
                "profile.invitations.nextBadge": "Nächster Erfolg",
                "profile.invitations.progress": "Fortschritt",
                "profile.invitations.achievement": "Leistung",
                "profile.invitations.topInviterAchieved": "Maximale Anzahl an Einladenden erreicht",
                "profile.invitations.badges.networkBuilder": "Netzwerk-Builder",
                "profile.invitations.badges.topInviter": "Maximaler Einladender",
                "profile.invitations.achievement.networkBuilderMessage": "Sie haben 20 Benutzer zu ArChat eingeladen.",
                "profile.invitations.achievement.topInviterMessage": "Sie haben 50 Benutzer zu ArChat eingeladen.",
                "profile.manage_plan": "Plan verwalten",
                "plan.current_plan": "Aktueller Plan",
                "plan.current": "Actual",
                "plan.footer_prefix": "Plan:",
                "plan.upgrade_to_pro": "Upgrade auf PRO",
                "plan.upgrade_to_foundation": "Upgrade auf FOUNDATION",
                "plan.payment_coming": "Die Zahlung mit Paddle wird in Kürze verfügbar sein. Von hier aus können Sie Ihre Pläne ändern.",
                "plan.payment_coming_title": "Bald",
                "plan.foundation_full": "Das STIFTUNGSkontingent ist ausgeschöpft (150 Gründer). Sie können PRO wählen.",
                "plan.sold_out": "Erschöpft",
                "plan.founder_spots_remaining": "Nur {count} Plätze verfügbar",
                "plan.founders_occupied": "vielbeschäftigte Gründer",
                "plan.upgrade_not_allowed": "Nur Benutzer mit einem KOSTENLOSEN Plan können ein Upgrade anfordern.",
                "plan.free_contacts": "Hasta 2 contactos",
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "Kontakte",
                "billing.usage.chars_month": "Charaktere pro Monat",
                "billing.usage.storage": "Gebrauchter Speicher",
                "billing.usage.devices": "Angeschlossene Geräte",
                "billing.loading": "Aufladen...",
                'billing.subscription.section_title': 'Abonnement und Abrechnung',
                'billing.subscription.provider_note': 'Anbieter',
                'billing.subscription.paddle_active': 'Paddle (aktiver Plan in der App)',
                'billing.subscription.mp_action_ok': 'Anfrage gespeichert. Wenn sich der Checkout nicht geöffnet hat, prüfen Sie die Verbindung oder versuchen Sie es erneut.',
                'billing.paddle.manage_subscription_button': 'Abonnement verwalten',
                'billing.paddle.portal_confirm_title': 'Abrechnungsportal',
                'billing.paddle.portal_confirm': 'Das sichere Paddle-Portal öffnet sich, um Zahlungsmethode und Rechnungen zu aktualisieren oder das Abonnement zu kündigen. Fortfahren?',
                'billing.paddle.portal_opened_hint': 'Das Paddle-Portal wurde in einem neuen Tab geöffnet. Aktualisieren Sie Ihr Profil, wenn der Plan nicht aktualisiert wurde.',
                'billing.paddle.portal_error': 'Paddle-Portal konnte nicht geöffnet werden. Versuchen Sie es später erneut oder kontaktieren Sie den Support.',
                'billing.paddle.no_link_error': 'Noch keine Paddle-Abonnement-Verknüpfung auf Ihrem Konto. Wenn Sie gerade bezahlt haben, warten Sie auf den Webhook oder kontaktieren Sie den Support.',
                'billing.paddle.api_not_configured': 'Auf dem Server fehlt die Paddle-API-Konfiguration (PADDLE_API_KEY). Ein Administrator muss sie setzen.',
                "billing.descriptions.contacts": "Gesamtzahl der in Ihrem Konto gespeicherten Kontakte",
                "billing.descriptions.storage": "Speicher für Dateien und Medien",
                "billing.descriptions.chars_month": "Charaktere wurden diesen Monat übersetzt",
                "billing.descriptions.devices": "Aktiv verbundene Geräte",
                'billing.paddle.return_title': 'Zahlung erhalten',
                'billing.paddle.return_body': 'Wenn Sie den Checkout abgeschlossen haben, wird Ihr Plan kurz nach Bestätigung durch Paddle aktualisiert. Sie können zur Startseite zurückkehren.',
                'billing.paddle.verifying': 'Plan wird geprüft…',
                'billing.paddle.not_logged_in': 'Melden Sie sich an, um den aktuellen Planstatus zu sehen.',
                'billing.paddle.plan_updated': 'Plan erfolgreich aktualisiert: {plan}',
                'billing.paddle.plan_current': 'Ihr aktueller Plan: {plan}',
                'billing.paddle.plan_current_founder': 'Sie sind jetzt Founder — {plan}',
                'billing.paddle.still_free_hint': 'Wenn Sie nach kurzer Wartezeit noch FREE sehen, kann der Webhook verzögert sein. Prüfen Sie die Server-Logs oder aktualisieren Sie die Seite.',
                'billing.paddle.pro_extra_hint': 'Sie können zur Startseite gehen, um Ihren Plan zu nutzen.',
                "avatar.errors.too_large": "Das Bild ist zu groß. Maximale Größe: 2 MB.",
                "avatar.preview.title": "Avatar-Vorschau",
                "profile.avatar.error_title": "Avatar konnte nicht aktualisiert werden",
                "profile.avatar.error.title": "Avatar konnte nicht aktualisiert werden",
                "profile.avatar.error.size": "Das Bild überschreitet die zulässige Größe. Das Maximum beträgt 2 MB.",
                "profile.avatar.tooLarge.title": "Bild zu groß",
                "profile.avatar.tooLarge.message": "Das Foto überschreitet die zulässige Größe. Das Maximum beträgt 2 MB.",
                "profile.avatar.uploadError.title": "Avatar konnte nicht aktualisiert werden",
                "profile.avatar.uploadError.message": "Beim Hochladen des Bildes ist ein Problem aufgetreten. Versuchen Sie es erneut.",
                "profile.saveSuccess.title": "Aktualisiertes Profil",
                "profile.saveSuccess.message": "Ihre Änderungen wurden erfolgreich gespeichert.",
                "profile.avatar.file_too_large": "Das Bild überschreitet die maximal zulässige Größe (2 MB).",
                "profile.avatar.file_too_large_hint": "Wählen Sie ein helleres Bild oder verkleinern Sie es und versuchen Sie es erneut.",
                "profile.photo.take.front": "Frontkamera",
                "profile.photo.take.back": "Rückfahrkamera",
                "profile.photo.take.webcam": "Webcam",
                "profile.photo.camera.front": "Frontkamera",
                "profile.photo.camera.back": "Rückfahrkamera",
                "profile.photo.camera.web": "Webcam",
                "profile.photo.close": "Schließen",
                "profile.photo.capture": "Erfassen",
                "block.toggle_error": "Konnte nicht gesperrt oder entsperrt werden.",
                "contact.favorite.add": "Zu Favoriten hinzufügen",
                "contact.favorite.remove": "Aus Favoriten entfernen",
                "contact.block.block": "Block",
                'contact.block.unblock': 'Entsperren',
                "conversation.notFound": "Konversation nicht gefunden",
                "help.howWorks.title": "👥 Wie ArChat® funktioniert (echter Flow)",
                "help.howWorks.step1.title": "1️⃣ Anmeldung",
                "help.howWorks.step1.point1": "Melden Sie sich mit Ihrem Spitznamen und Passwort an.",
                "help.howWorks.step1.point2": "Wenn Sie noch kein Konto haben, wird dieses automatisch erstellt.",
                "help.howWorks.step1.point3": "Sie akzeptieren die Allgemeinen Geschäftsbedingungen in Ihrer Sprache.",
                "help.howWorks.step1.point4": "Sie bestätigen Ihr Konto per E-Mail.",
                "help.howWorks.step2.title": "2️⃣ Private Einladungen",
                "help.howWorks.step2.point1": "Laden Sie Kontakte per E-Mail aus Ihrem Profil ein.",
                "help.howWorks.step2.point2": "Definieren Sie die Sprache und den Konversationsmodus, bevor Sie beginnen.",
                "help.howWorks.step2.point3": "Der Kontakt erhält eine private Einladung.",
                "help.howWorks.step2.point4": "Sie können sehen, ob es sich um „Ausstehend“, „Registriert“ oder „Bereit zum Chatten“ handelt",
                "help.howWorks.step2.point5": "Kontakte werden nicht gesucht, sie werden eingeladen.",
                "help.howWorks.step2.point6": "Kontakte werden nicht gesucht, sie werden eingeladen.",
                "help.howWorks.step3.title": "3️⃣ Kontakte und Gespräche",
                "help.howWorks.step3.point1": "Ihre Kontakte werden automatisch angezeigt, wenn:",
                "help.howWorks.step3.point2": "eine Einladung annehmen",
                "help.howWorks.step3.point3": "oder es gibt ein Gespräch",
                "help.howWorks.step3.point4": "Dürfen:",
                "help.howWorks.step3.point5": "markiere sie als Favoriten ⭐",
                "help.howWorks.step3.point6": "Weisen Sie ihnen benutzerdefinierte Aliase zu",
                "help.howWorks.step3.point7": "Fügen Sie private Notizen hinzu",
                "help.howWorks.step3.point8": "blockieren oder verwalten",
                "help.howWorks.step3.point9": "Es gibt keine öffentliche Agenda oder sichtbare Benutzer ohne Zustimmung.",
                "help.howWorks.step4.title": "4️⃣ Nachrichten mit Übersetzung",
                "help.howWorks.step4.point1": "Schreiben Sie immer in Ihrer Sprache.",
                "help.howWorks.step4.point2": "Das System übersetzt die Nachricht automatisch.",
                "help.howWorks.step4.point3": "Der Empfänger erhält es in seiner Sprache.",
                "help.howWorks.step4.point4": "Sie können die angewendete Übersetzung sehen.",
                "help.howWorks.step4.point5": "Wenn eine Übersetzung fehlschlägt, wird sie automatisch erneut versucht.",
                "help.howWorks.step4.point6": "ArChat® legt Wert auf Klarheit und Bedeutung, nicht nur auf Geschwindigkeit.",
                "help.privacy.title": "🔒 Privatsphäre und Kontrolle",
                "help.privacy.point1": "Ihr Profil ist standardmäßig privat.",
                "help.privacy.point2": "Nur diejenigen, die Sie einladen, können Sie sehen oder Ihnen schreiben.",
                "help.privacy.point3": "Die öffentliche Sichtbarkeit ist optional und standardmäßig deaktiviert.",
                "help.privacy.point4": "Aktive Sicherheit mit:",
                "help.privacy.point5": "CAPTCHA",
                "help.privacy.point6": "Geschwindigkeitsbegrenzung",
                "help.privacy.point7": "Fingerabdruck",
                "help.privacy.point8": "E-Mail-Bestätigung",
                "help.privacy.point9": "Ihre Gespräche sind nicht öffentlich oder indiziert.",
                "help.files.title": "📎 Dateien und Export",
                "help.files.point1": "Hängen Sie Bilder, Videos und PDF-Dokumente an.",
                "help.files.point2": "Nehmen Sie Fotos mit der Frontkamera, der Rückkamera oder der Webcam auf.",
                "help.files.point3": "Bilder werden automatisch komprimiert.",
                "help.files.point4": "Vorschau vor dem Senden.",
                "help.files.point5": "Fortschrittsbalken während des Ladens.",
                "help.files.point6": "Exportieren Sie ganze Konversationen nach:",
                "help.files.point7": "PDF",
                "help.files.point8": "HTML",
                "help.files.point9": "Enthält Nachrichten, Bilder und Dateien.",
                "help.files.point10": "Ihre Daten gehören Ihnen.",
                "help.experience.title": "🎨 Benutzererfahrung",
                "help.experience.point1": "Präsenzstatus und benutzerdefinierte Status mit Emoji.",
                "help.experience.point2": "Integrierte OpenMoji-Emojis.",
                "help.experience.point3": "Indikatoren lesen und schreiben.",
                "help.experience.point4": "Optimierte mobile Ansicht gleich dem Desktop.",
                "help.experience.point5": "Installierbare PWA-Anwendung.",
                "help.experience.point6": "Zwei Themen: Argentinien (Hellblau/Weiß/Gold) und Oscuro (Tiefviolett).",
                "help.experience.point7": "Profilbearbeitung ohne Softdrinks.",
                "help.experience.point8": "Länderauswahl mit automatischer Zeitzone.",
                "help.experience.point9": "Schnellzugriff mit Favoriten, Suche und Filtern.",
                "help.languages.title": "🌍 Sprachen",
                "help.languages.point1": "Unterstützung für {count} Sprachen.",
                "help.languages.point2": "Visueller Selektor mit Flaggen.",
                "help.languages.point3": "Benutzeroberfläche, AGB und E-Mails angepasst an die gewählte Sprache.",
                "help.languages.point4": "Automatische bidirektionale Übersetzung zwischen Benutzern.",
                "help.tipsNew.title": "💡 Tipps zur Nutzung von ArChat®",
                "help.tipsNew.point1": "Laden Sie nur Personen ein, mit denen Sie wirklich kommunizieren möchten.",
                "help.tipsNew.point2": "Verwenden Sie Aliase und private Notizen, um Kontakte zu organisieren.",
                "help.tipsNew.point3": "Markieren Sie Favoriten für den schnellen Zugriff.",
                "help.tipsNew.point4": "Überprüfen Sie die Übersetzung, bevor Sie wichtige Nachrichten senden.",
                "help.tipsNew.point5": "Exportieren Sie relevante Gespräche zur Sicherung oder Arbeit.",
                "help.tipsNew.point6": "Verwenden Sie ArChat®, wenn schriftliche Klarheit entscheidend ist.",
                "help.whySubscribe.title": "🚀 Warum ArChat® abonnieren?",
                "help.whySubscribe.point1": "ArChat® ist nicht darauf ausgelegt, mit irgendjemandem zu chatten,",
                "help.whySubscribe.point2": "sondern um besser mit denen zu kommunizieren, die wichtig sind.",
                "help.whySubscribe.point3": "Wenn Sie Folgendes benötigen:",
                "help.whySubscribe.point4": "Klarheit zwischen den Sprachen",
                "help.whySubscribe.point5": "echte Privatsphäre",
                "help.whySubscribe.point6": "Kontaktkontrolle",
                "help.whySubscribe.point7": "Konversationsexport",
                "help.whySubscribe.point8": "ein professionelles und geräuschfreies Erlebnis",
                "help.whySubscribe.point9": "ArChat® ist dafür konzipiert.",
                "help.message_time_context.title": "Zeitlicher Kontext von Nachrichten",
                "help.message_time_context.description": "Jede Nachricht kann die Ortszeit, Zeitzone und das Land des Absenders zum Zeitpunkt des Sendens speichern. Auf diese Weise können Sie sehen, wohin und zu welcher Zeit der andere Benutzer gesendet hat.",
                "help.message_time_context.point1": "Im FREE-Plan wird nur die Zeit in Ihrer Zeitzone (Empfänger) angezeigt.",
                "help.message_time_context.point2": "Im PRO-Plan werden zusätzlich die Ortszeit, das Land und die Zeitzone des Emittenten angezeigt.",
                "help.message_time_context.point3": "Der Kontext wird in jeder Nachricht historisch gespeichert.",
                "help.message_time_context.point4": "Erweiterte Prüffunktionen sind in höheren Plänen verfügbar.",
                'presence.custom.title': 'Benutzerdefinierter Status',
                'presence.custom.status': 'Benutzerdefinierter Status',
                'presence.custom.placeholder': 'Z. B.: Kaffee trinken ☕',
                "presence.custom.emoji": "Emoji (optional)",
                'presence.custom.emojiHelp': 'Waehle ein Emoji oder gib eines ein',
                'presence.custom.temporary': 'Temporarer Status (laeuft automatisch ab)',
                'presence.custom.expiration': 'Ablaufdatum',
                'presence.custom.expirationHelp': 'Der Status kehrt bei Ablauf zu "Online" zurueck',
                'presence.custom.suggestions': 'Vorschlaege',
                'presence.custom.preview': 'Vorschau',
                'presence.custom.save': 'Status speichern',
                'presence.custom.required': 'Benutzerdefinierter Status ist erforderlich',
                'presence.custom.maxLength': 'Maximal 64 Zeichen',
                'presence.custom.expirationRequired': 'Du musst ein Ablaufdatum auswaehlen',
                'presence.custom.expirationFuture': 'Das Ablaufdatum muss in der Zukunft liegen',
                'presence.custom.selectEmoji': 'Emoji auswaehlen',
                "invitation.success.title": "Einladung gesendet",
                "invitation.success.message": "Einladung erfolgreich gesendet.\\n\\nDer Kontakt erhält eine E-Mail mit einem Link zum Annehmen der Einladung. Sobald Sie akzeptiert haben, können Sie mit ihm chatten.",
                "invitation.top.title": "Top-Netzwerkbauer",
                "invitation.top.invitesSuffix": "Einladungen",
                "invitation.ranking.position": "Position",
                "invitation.ranking.user": "Benutzer",
                "invitation.ranking.validatedInvites": "Validierte Einladungen",
                "invitation.ranking.empty": "Es sind keine validierten Einladungen zum Anzeigen vorhanden.",
                "invitation.ranking.loading": "Rangliste wird geladen...",
                "invitation.ranking.loadError": "Das Ranking konnte nicht geladen werden.",
                "invitations.waitBeforeResend": "Sie können die Einladung noch nicht erneut senden. Sie müssen zwischen jedem Versand 10 Minuten warten, um den Gastbenutzer nicht zu spammen.",
                "invitations.captchaQuestion": "Wie viel ist %1 + %2?",
                "invitations.resendSuccess": "Die Einladung wurde erfolgreich weitergeleitet.",
                "invitations.dailyLimit": "Sie haben heute die maximal zulässige Anzahl erneuter Einreichungen erreicht.",
                "invitations.invalidEmail": "Der Mailserver hat gemeldet, dass diese Adresse ungültig ist.",
                "achievement.unlocked": "Erfolg freigeschaltet",
                "achievement.continue": "Weitermachen",
                'dashboard.not_available': 'Nicht verfügbar',
                "plan.errors.chatsLimit.title": "Konversationslimit erreicht",
                "plan.errors.chatsLimit.message": "Ihr aktueller Plan sieht eine Begrenzung der Anzahl der Gespräche vor, die Sie führen können.",
                "plan.errors.chatsLimit.solution": "Um mehr Konversationen zu erstellen, aktualisieren Sie Ihren Plan auf PRO.",
                "errors.generic": "Es ist ein unerwarteter Fehler aufgetreten. Versuchen Sie es erneut.",
                "errors.modal.title": "Fehler",
                "errors.modal.copyDetails": "Detail kopieren",
                "errors.modal.close": "Schließen",
                "errors.modal.reportSupport": "Dem Support melden",
                "errors.avatarTooLarge": "Das Bild überschreitet die zulässige Größe von 2 MB.",
                "errors.avatarTooLarge.title": "Bild zu groß",
                "errors.avatarTooLarge.message": "Das Bild überschreitet die zulässige Größe von 2 MB.",
                "errors.invalidImageType": "Die ausgewählte Datei ist kein gültiges Bild.",
                "errors.invalidImageType.title": "Ungültige Datei",
                "errors.invalidImageType.message": "Die ausgewählte Datei ist kein gültiges Bild.",
                "errors.uploadFailed": "Bild konnte nicht hochgeladen werden. Versuchen Sie es erneut.",
                "errors.uploadFailed.title": "Fehler beim Hochladen",
                "errors.uploadFailed.message": "Bild konnte nicht hochgeladen werden. Versuchen Sie es erneut.",
                "errors.conversationCreate": "Fehler beim Erstellen der Konversation. Bitte versuchen Sie es erneut.",
                "errors.conversationInvalidId": "Ungültige Konversations-ID.",
                "errors.conversationOpen": "Fehler beim Öffnen der Konversation. Bitte versuchen Sie es erneut.",
                "errors.favoriteUpdate": "Der Favorit konnte nicht aktualisiert werden",
                "errors.blockUpdate": "Die Sperre konnte nicht aktualisiert werden",
                "errors.messageEdit": "Fehler beim Bearbeiten der Nachricht.",
                "errors.foundation_sold_out": "Gründerplätze sind ausverkauft.",
                "errors.userInactive.title": "Konto deaktiviert",
                "errors.tenantMismatch.title": "Mieterfehler",
                'auth.tagline': 'Die Kraft, verstanden zu werden – unabhängig von der Sprache',
                'auth.sign_in': 'Anmelden',
                'auth.create_account': 'Konto erstellen',
                'ui.search_contact': 'Kontakt suchen...',
                'ui.language': 'Sprache',
                'profile.my_profile': 'Mein Profil',
                'profile.status': 'Zustand',
                'profile.invite_email': 'Kontakt per E-Mail einladen',
                'profile.sent_invitations': 'Gesendete Einladungen',
                'profile.users': 'Benutzer',
                'profile.settings': 'Einstellungen',
                'profile.appearance': 'Darstellung',
                'profile.logout': 'Abmelden',
                'contacts.mode': 'Modus',
                'contacts.sent': 'Gesendet',
                'contacts.actions': 'Aktionen',
                'contacts.pending': 'Ausstehend',
                'contacts.available': 'Verfügbar',
                'contacts.invited_registered': 'Eingeladen - Registriert',
                'table.email': 'E-Mail',
                'table.language': 'Sprache',
                'table.mode': 'Modus',
                'table.status': 'Zustand',
                'table.sent': 'Gesendet',
                'table.actions': 'Aktionen',
  'promotions.invite.message': 'Ich lade dich zu ArChat ein — sprich in jeder Sprache. Wir profitieren beide.',
  'promotions.progress.pending': 'Du hast ausstehende Einladungen, um Belohnungen freizuschalten.',
  'promotions.progress.in_progress': 'Deine Einladungen sind in Bearbeitung: Belohnungen werden nach einem echten Gespraech aktiviert.',
  'promotions.progress.remaining': 'Dir fehlen noch {count} Gespraech(e), um deine Belohnung zu erhalten.',
  'promotions.progress.sent_count': 'Gesendet',
  'promotions.progress.pending_count': 'Ausstehend',
  'promotions.progress.in_progress_count': 'In Bearbeitung',
  'promotions.progress.completed_count': 'Abgeschlossen',
  'promotions.banner.empty': 'Starte jetzt: Lade Kontakte ein und schalte Vorteile frei.',
  'promotions.banner.pending': 'Du hast ausstehende Einladungen: Fuehre ein echtes Gespraech und erhalte Belohnungen.',
  'promotions.banner.reward': 'Du hast bereits Belohnungen freigeschaltet! Lade weiter ein, um mehr zu gewinnen.',
  'promotions.cta.copy': 'Nachricht und Link kopieren',
  'promotions.cta.copied': 'Nachricht kopiert',
  'promotions.cta.copy_error': 'Nachricht konnte nicht kopiert werden',

  'promotions.title': 'Aktionen und Belohnungen',
  'promotions.subtitle': 'Lade Kontakte ein und schalte Vorteile durch echte Nutzung frei.',
  'promotions.how_it_works': 'So funktioniert es',
  'promotions.step1': 'Lade einen Kontakt ueber dein Profil ein.',
  'promotions.step2': 'Wenn die Einladung angenommen wird und ein echtes Gespraech stattfindet, wird sie automatisch validiert.',
  'promotions.step3': 'Die Belohnung wird gutgeschrieben und dein Fortschritt aktualisiert.',
  'promotions.rewards.title': 'Belohnungen',
  'promotions.reward.invite': 'Belohnung fuer jede validierte Empfehlung.',
  'promotions.reward.milestone': 'Bonus bei Wachstums-Meilensteinen.',
  'promotions.reward.ranking': 'Sichtbarkeit im Ranking der besten Netzwerk-Aufbauer.',
  'promotions.progress.title': 'Dein Fortschritt',
  'promotions.progress.sent': 'Gesendet',
  'promotions.cta.invite': 'Kontakt einladen',
  'promotions.banner': 'Aktiviere Aktionen: Lade ein und verdiene Belohnungen durch echte Nutzung.',
  'promotions.modal.title': 'Aktionsprogramm',
  'promotions.modal.body': 'Erhalte +10.000 Zeichen pro validierter Einladung.\\\\nLade heute ein und schalte Belohnungen frei.',
  'promotions.modal.cta': 'Aktionen ansehen',
                "app.install_ios_hint": "Zur Installation: Teilen > Zum Startbildschirm hinzufügen",
                'menu.promotions': 'Aktionen',
                "suggestions.new": "Neuer Vorschlag",
                "suggestions.empty": "Sie haben noch keine Vorschläge eingereicht.",
                "suggestions.admin_note": "Teamnotiz",
                "suggestions.status.pending": "Ohrring",
                "suggestions.status.reviewed": "Überarbeitet",
                "suggestions.status.planned": "Geplant",
                "suggestions.status.implemented": "Umgesetzt",
                "suggestions.status.rejected": "Abgelehnt",
                "referral.promo": "Laden Sie 10.000 Charaktere ein und gewinnen Sie",
                "referral.stats.sent": "Gesendet",
                "referral.stats.accepted": "Akzeptiert",
                "referral.stats.rewards": "Belohnungen",
                "referral.reward.pending": "Ohrring",
                "referral.reward.granted": "Gefüllt",
                "referral.reward.invalid": "Ungültig",
                "referral.reward.in_progress": "Im Einsatz",
                "referral.limit.reached": "Prämienlimit erreicht",
                "referral.waiting.usage": "Jeweils +10.000 Zeichen, wenn Sie und Ihr Gast mindestens eine echte Textnachricht im selben Chat senden (servervalidiert).",
                "common.avatar": "Avatar",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": "Es liegen noch keine Nachrichten vor",
                "messages.loading": "Nachrichten werden geladen...",
                "messages.connecting_server": "Verbindung zum Nachrichtenserver wird hergestellt...",
                "messages.pending_send_count": "{count} Nachricht(en) warten auf Zustellung",
                "presence.custom.suggestion.coffee": "Ein paar Freunde haben ☕",
                "presence.custom.suggestion.soccer": "Auf dem Platz ⚽",
                "presence.custom.suggestion.working": "Ich arbeite wie verrückt 💪",
                "presence.custom.suggestion.lunch": "Mittagessen 🍽️",
                "presence.custom.suggestion.family": "Familienessen 👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "Studieren 📚",
                "presence.custom.suggestion.travel": "Auf einer Reise ✈️",
                "presence.custom.suggestion.meeting": "Im Treffen 💼",
                "presence.custom.suggestion.resting": "Ausruhen 😴",
                "presence.custom.suggestion.gaming": "Videospiele spielen 🎮",
                "presence.custom.suggestion.reading": "Lesen 📖",
                "presence.custom.suggestion.offlineSoon": "Ich bin gleich wieder da ⏳",
                "invitation.safe.phase_notice": "Aktive Sicherheitsphase: Vorteile bis zur kommerziellen Aktivierung (keine wirklichen Auswirkungen auf die Grenzwerte).",
                "invitation.safe.generate_code": "Link/Code generieren",
                "invitation.safe.refresh_top3": "Top 3 aktualisieren",
                "invitation.safe.top_loading": "Top-Einladende werden geladen...",
                "invitation.safe.top_empty": "Es gibt noch keine eingeladenen Personen.",
                "invitation.safe.hide_full_ranking": "Vollständiges Ranking ausblenden",
                "invitation.safe.view_full_ranking": "Vollständiges Ranking ansehen",
                "invitation.safe.hide_metrics_dashboard": "Metrik-Dashboard ausblenden",
                "invitation.safe.view_metrics_dashboard": "Metrik-Dashboard anzeigen",
                "invitation.safe.prepared_link": "Link vorbereitet",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "Registrieren Sie sich bis zur Einladung",
                "invitation.safe.status_summary": "Statuszusammenfassung",
                "invitation.safe.summary.pending": "Ohrringe",
                "invitation.safe.summary.registered": "Eingetragen",
                "invitation.safe.summary.active": "Aktiv",
                "invitation.safe.summary.validated": "Validiert",
                "invitation.safe.summary.rejected": "Abgelehnt",
                "invitation.safe.sent_invitations": "Einladungen herausgegeben",
                "invitation.safe.table.id": "AUSWEIS",
                "invitation.safe.table.invited_email": "Gast-E-Mail",
                "invitation.safe.table.code": "Code",
                "invitation.safe.table.status": "Zustand",
                "invitation.safe.table.created": "Erstellt",
                "invitation.safe.empty_sent": "Es wurden noch keine Einladungen verschickt.",
                "invitation.safe.simulated_rewards": "Simulierte Belohnungen verdient",
                "invitation.safe.empty_rewards": "Derzeit keine simulierten Belohnungen.",
                "invitation.safe.error.load_status": "Der Einladungsstatus konnte nicht geladen werden.",
                "invitation.safe.error.generate_code": "Der Code konnte nicht generiert werden.",
                "invitation.safe.error.invalid_email": "Geben Sie eine gültige E-Mail-Adresse ein, um die Einladung zu registrieren.",
                "invitation.safe.error.register_pending": "Die ausstehende Einladung konnte nicht registriert werden.",
                "invitation.safe.success.code_generated": "Code erfolgreich generiert.",
                "invitation.safe.success.pending_registered": "Ausstehende Einladung im abgesicherten Modus registriert.",
                "invitation.status.deleted": "Eliminiert",
                "invitation.deleted.tooltip": "Diese Einladung wurde entfernt",
                "invitation.status.rejected": "Abgelehnt",
                'invitation.status.bounced': 'Zurückgewiesen',
                'invitation.status.unknown': 'Unbekannt',
                "dashboard.admin.title": "Wachstumskennzahlen",
                "dashboard.admin.newUsersToday": "Heute neue Benutzer",
                "dashboard.admin.messagesSentToday": "Heute gesendete Nachrichten",
                "dashboard.admin.translationsUsed": "Verwendete Übersetzungen",
                "dashboard.admin.invitesCreated": "Einladungen erstellt",
                "dashboard.admin.invitesValidated": "Validierte Einladungen",
                "dashboard.admin.inviteConversion": "Einladungsumwandlung",
                "dashboard.admin.kFactor": "K-Faktor",
                "dashboard.admin.newUsers": "Neue Benutzer",
                "dashboard.admin.messagesSent": "Gesendete Nachrichten",
                "dashboard.admin.noData": "Keine Daten",
                "dashboard.admin.kFactor.viral": "Viral",
                "dashboard.admin.kFactor.stable": "Stabil",
                "dashboard.admin.kFactor.low": "Niedrig",
                "dashboard.admin.emailMetrics": "E-Mail-Metriken",
                "dashboard.admin.email.sent": "Gesendet",
                "dashboard.admin.email.delivered": "Geliefert",
                "dashboard.admin.email.opened": "offen",
                "dashboard.admin.email.clicked": "Klicks",
                "dashboard.admin.email.bounced": "Abgeprallt",
                "dashboard.admin.email.deliveryRate": "Lieferrate",
                "dashboard.admin.email.openRate": "Öffnungsrate",
                "dashboard.admin.email.bounceRate": "Absprungrate",
                "dashboard.admin.funnelMetrics": "Trichtermetriken",
                "dashboard.admin.funnel.registered": "Eingetragen",
                "dashboard.admin.funnel.confirmed": "Bestätigt",
                "dashboard.admin.funnel.loggedIn": "Erster Login",
                "dashboard.admin.funnel.firstMessage": "Erste Nachricht",
                "dashboard.admin.funnel.abandoned": "Verlassen",
                "dashboard.admin.funnel.conversionRate": "Conversion-Rate",
                "dashboard.admin.funnel.activationRate": "Aktivierungsrate",
                "dashboard.admin.funnel.dropoffRate": "Abbrecherquote",
                "dashboard.admin.loading": "Messwerte werden geladen...",
                "dashboard.admin.errorLoad": "Das Metrik-Dashboard konnte nicht geladen werden.",
                "dashboard.admin.growthViral": "Viruswachstum",
                "dashboard.admin.growthStable": "Stabiles Wachstum",
                "dashboard.admin.growthLow": "Geringes Wachstum",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "Code",
                "errors.modal.message": "Nachricht",
                "errors.modal.path": "Route",
                "errors.modal.time": "Stunde",
                "errors.modal.timestamp": "Zeitstempel",
                "errors.modal.copied": "Detail kopiert",
                "errors.network": "Es konnte keine Verbindung zum Server hergestellt werden. Überprüfen Sie Ihre Verbindung.",
                "errors.unexpected": "Es ist ein unerwarteter Fehler aufgetreten. Versuchen Sie es erneut.",
                "errors.boundary.title": "REACT-FEHLER ERFASST",
                "errors.boundary.request_id": "X-Request-ID:",
                "errors.boundary.correlate": "Zuordnung zu backend/logs/structured.log",
                "errors.boundary.message_label": "Nachricht:",
                "errors.boundary.stack_trace": "Stack-Trace",
                "errors.boundary.component_stack": "Komponentenstapel",
                "errors.boundary.empty": "(leer)",
                "errors.boundary.reload_page": "Seite neu laden",
                "errors.ui_boundary.refresh": "Fehler in der ArChat-Schnittstelle – Neuladen der Seite",
                "bootstrap.error.title": "ArChat® – Boot-Fehler",
                "common.reload": "Aufladen",
                "admin.access_denied.message": "Nachricht",
                "admin.access_denied.title": "Titel",
                "admin.action.change_plan": "Plan ändern",
                "admin.action.reactivate": "Reaktivieren",
                "admin.action.suspend": "Aussetzen",
                "admin.action.view": "Sicht",
                "admin.confirm.change_plan.message": "Nachricht",
                "admin.confirm.change_plan.title": "Titel",
                "admin.confirm.suspend.message": "Nachricht",
                "admin.confirm.suspend.title": "Titel",
                "admin.details.created": "Erstellt",
                "admin.details.current_plan": "Aktueller Plan",
                "admin.details.domain": "Domain",
                "admin.details.last_activity": "Letzte Aktivität",
                "admin.details.name": "Süßkartoffel",
                "admin.details.plan": "Planen",
                "admin.details.status": "Status",
                "admin.details.subscription": "Abonnement",
                "admin.details.tenant_id": "Mieter-ID",
                "admin.details.tenant_info": "Mieterinfo",
                "admin.details.usage": "Verwendung",
                "admin.error.change_plan": "Plan ändern",
                "admin.error.generic": "Generisch",
                "admin.error.load_details": "Details laden",
                "admin.error.load_tenants": "Mieter laden",
                "admin.error.reactivate": "Reaktivieren",
                "admin.error.suspend": "Aussetzen",
                "admin.error.title": "Titel",
                "admin.filter.active": "Aktivieren",
                "admin.filter.all_plans": "Alle Pläne",
                "admin.filter.all_status": "Alle Status",
                "admin.filter.suspended": "Aussetzen",
                "admin.limit.devices": "Geräte",
                "admin.limit.invitations": "Einladungen",
                "admin.limit.messages": "Nachrichten",
                "admin.limit.storage": "Lagerung",
                "admin.limit.users": "Benutzer",
                "admin.loading": "Laden",
                "admin.no_tenants": "Nichtmieter",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "Aktivieren",
                "admin.status.suspended": "Aussetzen",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "Letzte Zahlung",
                "admin.subscription.status": "Status",
                "admin.subtitle": "Untertitel",
                "admin.success.plan_changed": "Plan geändert",
                "admin.success.tenant_reactivated": "Mieter reaktiviert",
                "admin.success.tenant_suspended": "Mieter suspendiert",
                "admin.success.title": "Titel",
                "admin.table.actions": "Aktionen",
                "admin.table.messages": "Nachrichten",
                "admin.table.name": "Süßkartoffel",
                "admin.table.plan": "Planen",
                "admin.table.status": "Status",
                "admin.table.storage": "Lagerung",
                "admin.table.tenant_id": "Mieter-ID",
                "admin.table.users": "Benutzer",
                "admin.title": "Titel",
                "admin.usage.devices": "Geräte",
                "admin.usage.invitations": "Einladungen",
                "admin.usage.messages": "Nachrichten",
                "admin.usage.storage": "Lagerung",
                "admin.usage.users": "Benutzer",
                "auth.login": "Login",
                "auth.register": "Registrieren",
                "auth.reset_password": "Passwort zurücksetzen",
                "billing.cancel.button": "Taste",
                "billing.cancel.canceling": "Stornieren",
                "billing.cancel.confirm": "Bestätigen",
                "billing.cancel.error": "Fehler",
                "billing.cancel.success": "Erfolg",
                "billing.character_billing.characters_used": "Verwendete Zeichen",
                "billing.character_billing.consumption_pct": "Verbrauchsanteil",
                "billing.character_billing.days_remaining": "Tage übrig",
                "billing.character_billing.deletion_date": "Löschdatum",
                "billing.character_billing.period_start": "Beginn der Periode",
                "billing.character_billing.renewal_date": "Verlängerungsdatum",
                "billing.character_billing.title": "Titel",
                "billing.current_plan": "Aktueller Plan",
                "billing.founder_badge": "Gründerabzeichen",
                "billing.no_plans": "Planen Sie nicht",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "Nächste Zahlung",
                "billing.subscription.plan": "Planen",
                'billing.subscription.price': 'Planpreis',
                "billing.subscription.started": "Begonnen",
                "billing.subscription.status": "Status",
                'billing.subscription.mp_flow.subscribe_failed': 'Abonnement konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
                'billing.subscription.mp_flow.change_plan_failed': 'Planwechsel fehlgeschlagen. Bitte versuchen Sie es erneut.',
                'billing.subscription.mp_status.pending': 'Ausstehend',
                'billing.subscription.mp_status.authorized': 'Autorisiert',
                'billing.subscription.mp_status.active': 'Aktiv',
                'billing.subscription.mp_status.paused': 'Pausiert',
                'billing.subscription.mp_status.cancelled': 'Storniert',
                'billing.subscription.mp_status.inactive': 'Inaktiv',
                'billing.subscription.mp_status.unknown': 'Unbekannt',
                "billing.unlimited": "Unbegrenzt",
                "billing.update_plan": "Plan aktualisieren",
                "billing.update_plan_modal.title": "Titel",
                "billing.usage.loading": "Laden",
                "common.accept": "Akzeptieren",
                "common.confirmPassword": "Passwort bestätigen",
                'common.continue': 'Weiter',
                "common.error": "Fehler",
                "dashboard.upgrade.to_plan": "Planen",
                "emoji.noResults": "Keine Ergebnisse",
                "emoji.pick": "Wählen",
                "export.restricted.message": "Nachricht",
                "export.restricted.title": "Titel",
                "export.restricted.upgrade": "Upgrade",
                "founder.*": "*",
                "help.faq.a1": "A1",
                "help.faq.a2": "A2",
                "help.faq.a3": "A3",
                "help.faq.a4": "A4",
                "help.faq.a5": "A5",
                "help.faq.a6": "A6",
                "help.faq.a7": "A7",
                "help.faq.q1": "Q1",
                "help.faq.q2": "Q2",
                "help.faq.q3": "Q3",
                "help.faq.q4": "Q4",
                "help.faq.q5": "F5",
                "help.faq.q6": "F6",
                "help.faq.q7": "F7",
                "help.faq.title": "Titel",
                "help.howWorks.step4.point7": "Punkt7",
                "help.message_time_context.free_vs_pro": "Kostenlos vs. Pro",
                "help.message_time_context.point5": "Punkt 5",
                "help.plans.enterprise.benefits": "Vorteile",
                "help.plans.enterprise.description": "Beschreibung",
                "help.plans.enterprise.title": "Titel",
                "help.plans.foundation.devices": "Geräte",
                "help.plans.free.description": "Beschreibung",
                "help.plans.free.devices": "Geräte",
                "help.plans.free.limits": "Grenzen",
                "help.plans.free.title": "Titel",
                "help.plans.intro": "Einführung",
                "help.plans.pro.benefits": "Vorteile",
                "help.plans.pro.description": "Beschreibung",
                "help.plans.pro.devices": "Geräte",
                'help.plans.pro.price': '$19 / Monat',
                "help.plans.pro.title": "Titel",
                "help.plans.pro.upgrade": "Upgrade",
                "help.plans.title": "Titel",
                "help.plans.urgent_slots_badge": "Abzeichen für dringende Spielautomaten",
                "help.slogan.final": "Ende",
                "help.suggestions.point1": "Punkt1",
                "help.suggestions.point2": "Punkt2",
                "help.suggestions.title": "Titel",
                "invitation.already_contact_added": "Kontakt bereits hinzugefügt",
                "invitation.already_contact_title": "Titel bereits kontaktiert",
                "invitation.already_pending": "Bereits ausstehend",
                "invitation.language.invalid": "Ungültig",
                "message.send": "Schicken",
                "message.sendFile": "SendFile",
                "messages.conversations": "Gespräche",
                "messages.no_conversations_subtitle": "Keine Untertitel für Gespräche",
                "messages.no_conversations_title": "Kein Unterhaltungstitel",
                "presence.custom.edit": "Bearbeiten",
                "profile.enrichment.country": "Land",
                "profile.enrichment.country.select": "Wählen",
                "profile.enrichment.description": "Beschreibung",
                "profile.enrichment.org_size": "Organisationsgröße",
                "profile.enrichment.org_size.placeholder": "Platzhalter",
                "profile.enrichment.save": "Speichern",
                "profile.enrichment.skip": "überspringen",
                "profile.enrichment.title": "Titel",
                "profile.enrichment.usage_type.label": "Etikett",
                "profile.enrichment.usage_type.placeholder": "Platzhalter",
                "profile.founderPosition": "GründerPosition",
                "settings.confirmations.description": "Beschreibung",
                "settings.confirmations.disable": "Deaktivieren",
                "settings.confirmations.title": "Titel",
                "settings.confirmations.updated": "Aktualisiert",
                "settings.title": "Titel",
                "theme.description": "Beschreibung",
                "google.unavailable_tenant": "Google ist für diesen Mandanten nicht verfügbar.",
                "google.unavailable": "Google nicht verfügbar.",
                "google.verify_client_id": "Überprüfen Sie die Client-ID in der Google Cloud Console.",
                'google.login_aria': 'Mit Google anmelden',
                "message.preview_alt": "Vorschau",
                "message.image_attachment_alt": "Angehängtes Bild",
                "profile.avatar.alt": "Avatar",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "Top-Einladende werden geladen...",
                "invitation.top.empty": "Noch keine vorgestellten Einlader.",
                "invitation.contacts.title": "Kontakte einladen",
                "invitation.contacts.safe_phase_note": "Sichere Phase aktiv: anstehende Leistungen ohne Auswirkung auf reale Grenzwerte.",
                "invitation.contacts.generate_code": "Code/Link generieren",
                "invitation.contacts.refresh_top3": "Top 3 aktualisieren",
                "invitation.contacts.hide_full_ranking": "Vollständiges Ranking ausblenden",
                "invitation.contacts.show_full_ranking": "Vollständiges Ranking anzeigen",
                "invitation.contacts.hide_metrics_dashboard": "Metrik-Dashboard ausblenden",
                "invitation.contacts.show_metrics_dashboard": "Metrik-Dashboard anzeigen",
                "invitation.contacts.prepared_link_label": "Vorbereiteter Link:",
                "invitation.contacts.email_placeholder": "email@domain.com",
                "invitation.contacts.register_pending": "Registrieren Sie sich bis zur Einladung",
                "invitation.contacts.status_summary": "Statuszusammenfassung",
                "invitation.contacts.sent_invitations": "Einladungen verschickt",
                "invitation.contacts.invited_email": "Eingeladene E-Mail",
                "invitation.contacts.code": "Code",
                "invitation.contacts.no_sent_invitations": "Ich habe noch keine Einladungen verschickt.",
                "invitation.contacts.simulated_rewards": "Simulierte Belohnungen erhalten",
                "invitation.contacts.no_simulated_rewards": "Noch keine simulierten Belohnungen.",
                "common.id": "AUSWEIS",
                "common.created": "Erstellt",
                'plan.pro_contacts': 'Bis zu 100 Kontakte pro Nutzer',
                "common.status": "Status",
                "login.prompt_create_account_with_name": "Möchten Sie ein Konto mit diesem Namen erstellen?",
                'plans.upgrade.title': 'Plan aktualisieren',
                'plans.upgrade.comparison': 'Planvergleich',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'Jederzeit kündbar',
                'plans.actions.upgrade_pro': 'Auf PRO upgraden',
                'plans.actions.become_founder': 'Founder werden',

                'plans.modal.card.current_badge': 'Dein aktueller Tarif',

                'plans.modal.card.lower_tier': 'Unterhalb deines aktiven Tarifs',

                'plans.modal.card.manage_in_profile': 'Zum Ändern oder Kündigen: Abonnement und Abrechnung im Profil.',
                'plans.modal.card.cancel_subscription': 'Abonnement kündigen',
                'plans.modal.cancel_confirm.title': 'Abonnement kündigen oder verwalten',
                'plans.modal.cancel_confirm.body': 'Es öffnet sich ein neuer Tab mit dem sicheren Paddle-Portal. Dort können Sie Zahlungsmethode und Rechnungen verwalten oder kündigen.',
                'plans.modal.cancel_confirm.continue_button': 'Weiter',
                'plans.modal.cancel_confirm.back_button': 'Zurück',
                'plans.modal.cancel_paddle_fallback.title': 'Abonnement verwalten',
                'plans.modal.cancel_paddle_fallback.body': 'Das Paddle-Abrechnungsportal wird in dieser Umgebung nicht geöffnet (z. B. lokale Entwicklung oder noch keine Verknüpfung). Pläne können Sie hier weiterhin einsehen und vergleichen.',
                'plans.modal.cancel_paddle_fallback.confirm': 'Alles klar',
                'plans.upgrade_required': 'Im PRO-Tarif verfügbar',
                'settings.heading': 'Einstellungen',
                "settings.dashboard": "Armaturenbrett",
                'settings.dashboardDescription': 'Lokale Einstellungen für Start-Panel und sichtbare Kacheln.',
                'settings.dashboardGridHeading': 'Panel-Kacheln',
                'settings.dashboardShowOnStartDescription': 'Wenn ein, öffnet sich das Dashboard nach der Anmeldung statt der Kontaktliste.',
                'settings.dashboardBlockWelcome': 'Willkommen',
                'settings.dashboardBlockUsage': 'Plannutzung',
                'settings.dashboardBlockFiles': 'Meine Dateien',
                'settings.dashboardBlockPromotions': 'Aktionen',
                'settings.dashboardBlockSessions': 'Sitzungen',
                'settings.dashboardWelcomeDescription': 'Erste Schritte, Einladung und Hilfe-Shortcuts.',
                'settings.dashboardUsageDescription': 'Nutzung vs. Limits: Kontakte, Zeichen, Speicher, Geräte.',
                'settings.dashboardFilesDescription': 'Übersicht sichtbarer Dateien und Speicher in „Meine Dateien“.',
                'settings.dashboardPromotionsDescription': 'Aktionsübersicht und Link zum Programm.',
                'settings.dashboardSessionsDescription': 'Aktive Sitzungen und Geräte; andere Sitzungen schließen falls möglich.',
                'settings.enabled': 'An',
                'settings.disabled': 'Aus',
                'settings.showDashboardOnStart': 'Dashboard nach der Anmeldung anzeigen',
                'settings.showWelcomeBlock': 'Willkommens-Block anzeigen',
                'settings.showPromotionsBlock': 'Aktions-Block anzeigen',
                'settings.showUsageBlock': 'Plannutzung anzeigen',
                'settings.showRecentConversationsBlock': 'Letzte Unterhaltungen anzeigen (letzte Nachricht pro Kontakt)',
                'settings.showSessionsBlock': 'Aktive Sitzungen anzeigen',
                'settings.showFilesBlock': 'Dateiübersicht anzeigen',
                'settings.dashboardLocalNote': 'Diese Einstellungen bleiben lokal im Browser, bis es eine Profil-API gibt.',
                'settings.appearanceSettings': 'Erscheinungsbild',
                'settings.argentinaTheme': 'Argentinien-Design',
                'settings.darkMode': 'Dunkelmodus',
                'settings.language': 'Sprache',
                'settings.messageSound': 'Nachrichtenton',
                'settings.playSoundDescription': 'Ton bei neuen Nachrichten oder wichtigen Hinweisen abspielen.',
                'settings.messageSoundEnabled': 'An',
                'settings.messageSoundDisabled': 'Aus',
                'settings.accountSettings': 'Konto',
                'settings.deleteAccount': 'Konto löschen',
                'settings.deleteAccountWarning': 'Dies ist dauerhaft. Ihre Daten, Nachrichten, Kontakte und Einstellungen werden gemäß dem Löschverfahren der Plattform entfernt.',
                'settings.deleteMyAccount': 'Mein Konto löschen',
                'dashboard.contacts': 'Kontakte',
                'dashboard.characters': 'Zeichen',
                'dashboard.storage': 'Speicher',
                'dashboard.active_devices': 'Aktive Geräte',
                'dashboard.need_more_resources': 'Benötigst du mehr Ressourcen?',
                'dashboard.upgrade_message': 'Upgrade deinen Plan, um mehr Kontakte, Zeichen, Speicher und aktive Geräte zu erhalten.',
                'dashboard.upgrade_button': 'Auf PRO upgraden',
                'dashboard.upgrade_button_pro': 'Auf PRO upgraden',
                'dashboard.upgrade_button_foundation': 'Auf FOUNDATION upgraden',
                'files.preview': 'Vorschau',
                'files.previewFile': 'Dateivorschau',
                'files.previewUnavailable': 'Vorschau nicht möglich.',
                'files.previewLoading': 'Vorschau wird geladen…',
                'files.openPreview': 'Vorschau',
                'files.downloadFile': 'Datei herunterladen',
                'files.downloadFailed': 'Die Datei konnte nicht heruntergeladen werden. Verbindung und Sitzung prüfen und erneut versuchen.',
                'files.closePreview': 'Vorschau schließen',
                'files.unsupportedPreview': 'Für diesen Dateityp ist keine Vorschau verfügbar. Sie können die Angaben sehen oder die Datei herunterladen.',
                'files.pdfPreviewHelp': 'Dieser Browser zeigt die PDF ggf. nicht eingebettet. Zum Ansehen herunterladen.',
                'files.labelFileType': 'Typ',
                'files.previewForbidden': 'Keine Berechtigung für die Vorschau.',
                'files.previewNotFound': 'Datei nicht verfügbar oder nicht mehr sichtbar.',
                'files.unavailableForFree': '„Meine Dateien“ ist im FREE-Tarif nicht enthalten.',
                'files.availableInFoundationAndPro': '„Meine Dateien“ ist in FOUNDATION und PRO verfügbar.',
                'files.filesFeatureRestricted': 'Diese Funktion ist in Ihrem Tarif nicht verfügbar.',
                'files.filesLoadError': 'Fehler beim Laden der Dateien.',
                'files.uploadUnavailableForFree': 'Dateien senden ist im FREE-Tarif nicht verfügbar.',
                'files.uploadAvailableInFoundationAndPro': 'Datei-Upload ist in FOUNDATION und PRO verfügbar.',
                'files.recipientStorageFull': 'Der Empfänger hat keinen freien Speicherplatz für diese Datei.',
                'files.recipientNoAvailableStorage': 'Der Empfänger hat keinen verfügbaren Speicherplatz für diese Datei.',
                'files.storageQuotaExceeded': 'Sie haben das Speicherlimit Ihres Tarifs erreicht.',
                'files.freeStorageLimit': 'Im FREE-Tarif sind 5 MB Speicher für empfangene Dateien enthalten.',
                'settings.unreadEmailReminderSection': 'E-Mail-Zusammenfassung ungelesen',
                'settings.unreadEmailReminderDescription': 'Wenn neue Nachrichten oder Dateien länger ungelesen bleiben als unten eingestellt, sendet ArChat eine zusammengefasste E-Mail (nicht pro Nachricht).',
                'settings.unreadEmailReminderToggle': 'Zusammenfassungen per E-Mail senden',
                'settings.unreadEmailDelayHours': 'Wartezeit vor dem Versand (Stunden)',
                'settings.unreadEmailDelayHint': '1–168 Stunden (max. eine Woche). Die E-Mail nutzt die Profilsprache.',
                'subjects.title': 'Themen',
                'subjects.singular': 'Thema',
                'subjects.plural': 'Themen',
                'subjects.general': 'Allgemein',
                'subjects.new': 'Neues Thema',
                'subjects.create': 'Thema erstellen',
                'subjects.rename': 'Umbenennen',
                'subjects.finish': 'Abschließen',
                'subjects.reopen': 'Wieder öffnen',
                'subjects.select': 'Weiter',
                'subjects.status.open': 'Offen',
                'subjects.status.pending': 'Ausstehend',
                'subjects.status.finished': 'Abgeschlossen',
                'subjects.limitReached': 'Sie haben das Limit aktiver Themen in dieser Unterhaltung erreicht. Schließen Sie ein Thema ab, um ein neues anzulegen.',
                'subjects.limitReachedFree': 'Im FREE-Tarif sind bis zu 3 aktive Themen pro Unterhaltung möglich. Schließen Sie ein Thema ab, um ein neues anzulegen.',
                'subjects.limitReachedPro': 'Im PRO-Tarif sind bis zu 5 aktive Themen pro Unterhaltung möglich. Schließen Sie ein Thema ab, um ein neues anzulegen.',
                'subjects.limitReachedFoundation': 'Im FOUNDATION-Tarif sind bis zu 5 aktive Themen pro Unterhaltung möglich. Schließen Sie ein Thema ab, um ein neues anzulegen.',
                'subjects.activeLimitsLine': 'Aktive Themen: {current} / {max}',
                'subjects.closedListTitle': 'Geschlossene Themen',
                'subjects.viewClosed': 'Geschlossene Themen anzeigen',
                'subjects.noClosedSubjects': 'Es gibt keine geschlossenen Themen.',
                'subjects.reopenSubject': 'Wieder öffnen',
                'subjects.reopenedSubjects': 'Wieder geöffnete Themen',
                'subjects.reopenLimitReached':
                  'Sie haben das Limit aktiver Themen erreicht. Schließen Sie ein anderes Thema ab, um dieses wieder zu öffnen.',
                'subjects.ownerOnlyReopen':
                  'Nur die Person, die dieses Thema erstellt hat, kann es wieder öffnen.',
                'subjects.modal.title': 'Themen der Unterhaltung',
                'subjects.modal.subtitle': 'Wählen oder verwalten Sie die Themen dieser Unterhaltung.',
                'subjects.contactLabel': 'KONTAKT:',
                'subjects.ownerOnlyRename': 'Nur der Ersteller dieses Themas kann den Namen ändern.',
                'subjects.ownerOnlyStateChange': 'Nur der Ersteller dieses Themas kann den Status ändern.',
                'subjects.createdByOther': 'Dieses Thema wurde von der anderen Person erstellt. Sie können antworten, aber den Namen nicht ändern.',
                'subjects.empty': 'Keine Themen anzuzeigen.',
                'subjects.noResults': 'Keine Themen gefunden.',
                'subjects.error.generic': 'Aktion konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
                'subjects.error.featureDisabled': 'Themen sind in dieser Umgebung nicht verfügbar.',
                'subjects.error.duplicateName': 'Es gibt bereits ein aktives Thema mit diesem Namen.',
                'subjects.error.ownerRequired': 'Sie haben keine Berechtigung, dieses Thema zu ändern.',
                'subjects.error.defaultCannotRename': 'Das Thema „Allgemein“ kann nicht umbenannt werden.',
                'subjects.error.defaultCannotFinish': 'Das Thema „Allgemein“ kann nicht abgeschlossen werden.',
                'subjects.current': 'Thema',
                'subjects.change': 'Thema ändern',
                'subjects.currentLabel': 'Thema:',
                'subjects.changeSubject': 'Thema ändern',
                'subjects.closedCannotSend': 'Dieses Thema ist abgeschlossen. Öffnen Sie es wieder, um neue Nachrichten zu senden.',
                'subjects.selectBeforeSend': 'Wählen Sie im Dialog ein Thema, um Nachrichten anzuzeigen und zu senden.',
                'subjects.loadingMessages': 'Nachrichten für dieses Thema werden geladen…',
                'subjects.messageFilterError': 'Nachrichten für dieses Thema konnten nicht geladen werden.',
                ...PRESET_LOCALES.de,
                "auth.login.clear_password_lock_after_reset": "Ich habe mein Passwort bereits geändert (z. B. auf einem anderen Gerät)",
                "auth.signup_disabled": "Die Registrierung eines neuen Kontos ist in dieser Umgebung vorübergehend deaktiviert.",
                "auth.reset_user_not_found": "Wir haben kein mit dieser E-Mail verknüpftes Konto gefunden. Überprüfen Sie die korrekte Schreibweise oder erstellen Sie ein neues Konto.",
                "account.not_found": "Konto nicht gefunden.",
                "auth.pending_activation.title": "Aktivierung des Kontos steht aus",
                "auth.pending_activation.body": "Ihr Konto ist noch nicht aktiviert. Überprüfen Sie Ihre E-Mails und bestätigen Sie Ihre Registrierung, um ArChat beizutreten.",
                "auth.pending_activation.back_to_login": "Zurück zum Login",
                "auth.pending_activation.support_prefix": "Brauchen Sie Hilfe? Kontaktieren Sie den Support:",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "E-Mail zum erneuten Senden der Aktivierung",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "Geben Sie die E-Mail-Adresse ein, mit der Sie sich registriert haben, um die Aktivierung erneut zu senden.",
                "auth.pending_activation.sent_title": "Aktivierungs-E-Mail gesendet",
                "auth.pending_activation.sent_body": "Wenn die E-Mail einem ausstehenden Konto entspricht, senden wir Ihnen einen neuen Aktivierungslink. Überprüfen Sie Ihren Posteingang und auch Spam- oder Junk-Mails.",
                "auth.pending_activation.soft_error_title": "Erneutes Senden nicht möglich",
                "auth.pending_activation.soft_error_body": "Wir konnten die erneute Sendung zu diesem Zeitpunkt nicht bearbeiten. Versuchen Sie es in ein paar Minuten noch einmal oder schreiben Sie uns an info@archat.com.ar.",
                "auth.pending_activation.resend_again": "Nochmals senden",
                "menu.plans": "Pläne",
                "files.title": "meine Dateien",
                "files.filter_all": "Alle",
                "files.filter_sent": "Gesendet",
                "files.filter_received": "Erhalten",
                "files.filter_images": "Bilder",
                "files.filter_documents": "Unterlagen",
                "files.col_name": "Name",
                "files.col_size": "Größe",
                "files.col_date": "Datum",
                "files.col_direction": "Dir.",
                "files.col_actions": "Aktionen",
                "files.sent": "📤 Gesendet",
                "files.received": "📥 Erhalten",
                "files.download": "Entladung",
                "files.delete_for_me": "Für mich löschen",
                "files.delete_confirm_title": "Datei löschen",
                "files.delete_confirm_message": "Diese Datei wird aus Ihrem Konto gelöscht. Es wird nicht für die andere Person gelöscht. Weitermachen?",
                "files.empty": "Sie haben keine Dateien.",
                "files.error_loading": "Fehler beim Hochladen der Dateien.",
                "files.load_more": "Mehr laden",
                "message.status.sending": "Senden…",
                "message.status.failed": "Nicht gesendet",
                "message.status.sent": "Gesendet",
                "message.status.delivered": "Geliefert",
                "message.status.read": "Lesen",
                "home.public_nav.pricing": "Preise",
                "home.public_nav.aria": "Hauptnavigation der Website",
                "home.public_footer.aria": "Rechtliche Links",
                "home.pricing_link": "Pläne und Preise",
                "publicPricing.nav.back_home": "← Startseite",
                "publicPricing.title": "Pläne und Preise",
                "publicPricing.subtitle": "Transparente und abgestimmte Grenzen für die ArChat-Abonnement-Engine. Kommerzielle Preise in USD für internationale Kassen (z. B. Paddle).",
                "publicPricing.commercial_note": "Funktionsgrenzen stammen von PlanConstants/PlanResolver; Ihr Konto kann plan_limits in der Datenbank anwenden. Die Händlerabrechnung erfolgt über Paddle (oder andere von ArChat offiziell benannte Prozessoren) mit USD-Preisen wie angegeben.",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "Gleiche technische Grenzen wie PRO (Premium-Vertrag).",
                "publicPricing.same_limits_foundation": "Gleiche technische Grenzen wie FOUNDATION (Premiumvertrag).",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "30.000 Zeichen pro Monat und Konto.",
                "publicPricing.free.b2": "Bis zu 2 Kontakte pro Benutzer; Bis zu 2 aktive Gespräche pro Konto.",
                "publicPricing.free.b3": "Keine Anhänge oder Stauraum; ohne Datenexport.",
                "publicPricing.free.b4": "Nachrichtenverlauf bis zu 30 Tage; 1 Gerät pro Benutzer.",
                "publicPricing.free.b5": "34 Nachrichten/Tag und 1.000 Nachrichten/Monat (Mandant); bis zu 20 Einladungen pro Tag.",
                "publicPricing.premium.b1": "300.000 Zeichen pro Monat und Konto; bis zu 100 Kontakte pro Benutzer.",
                "publicPricing.premium.b2": "Unbegrenzte Gespräche und Chats (Mieter); 1.667 Nachrichten/Tag und 50.000/Monat.",
                "publicPricing.premium.b3": "Bis zu 50 MB Speicher (Mandant); bis zu 3 Geräte pro Benutzer.",
                "publicPricing.premium.b4": "Unbegrenzte Einladungen (Mieter); Export, automatische Übersetzung und Dateien nach Plan.",
                "publicPricing.premium.b5": "FOUNDATION: gleicher technischer Vertrag wie PRO, plus Gründerprogramm (150 Plätze). PRO: Premium-Standard.",
                "publicPricing.foundation.founder_note": "Kommerzielles Gründerprogramm: begrenzte Anzahl von {slots} Plätzen (siehe Planzusammenfassung). Gleiche PRO-Limits, sobald das Abonnement aktiviert ist.",
                "publicPricing.cta.start_free": "Kostenloses Konto erstellen",
                "publicPricing.cta.register_paid": "Benutzerkonto erstellen",
                "publicPricing.paddle_hint": "Der Checkout mit dem ausgewählten Prozessor wird innerhalb der Anwendung abgeschlossen, wenn der Ladevorgang aktiviert ist.",
                "publicPricing.legal.nav_label": "Legal",
                "publicPricing.legal.terms": "Nutzungsbedingungen",
                "publicPricing.legal.privacy": "Datenschutzrichtlinie",
                "publicPricing.legal.refund": "Rückerstattungsrichtlinie",
                "profile.security.privacy_note": "Verwalten Sie den Datenschutz und die Sicherheit Ihres Kontos.",
                "profile.security.sessions_title": "Aktive Sitzungen",
                "profile.security.current": "Aktuelle Sitzung",
                "profile.plan.foundation.description": "FOUNDATION-Plan (Founder): gleiche Premium-Nutzung wie PRO, mit Founder-Programm und begrenztem Platzangebot (150 Plätze).",
                "billing.view_plans": "Siehe Pläne",
                "billing.paddle.cancel_via_portal": "Abo kündigen",
                "billing.paddle.test_access_denied_body": "Auf diesem Server ist der Abrechnungsbetrieb eingeschränkt (Testmodus bzw. Testliste). Wenn Sie bereits mit einem echten Konto bezahlt haben, muss in der Produktion die Zahlung für alle Benutzer zugelassen werden (z. B. PAYMENTS_ALLOW_ALL_BILLING_USERS) oder diese Einschränkung muss deaktiviert werden. Kontaktieren Sie den Support.",
                "attachment.storage_insufficient_precheck.title": "Unzureichender Platz",
                "attachment.storage_insufficient_precheck.message": "Die Datei wiegt {fileSizeMb} MB und Ihnen stehen nur {availableMb} MB zur Verfügung. Geben Sie Speicherplatz frei oder verbessern Sie Ihren Plan, um fortzufahren.",
                "attachment.files_disabled.title": "Planlimit",
                "attachment.files_disabled.message": "Ihr aktueller Plan beinhaltet keinen Dateiversand. Verbessern Sie Ihren Plan, um fortzufahren.",
                "contacts.viewContactInfo": "Kontaktdaten anzeigen",
                "contacts.contactInfoTitle": "Kontaktdaten",
                "contacts.phone": "Telefon",
                "contacts.bio": "Biographie",
                "contacts.notProvided": "Nicht informiert",
                "contacts.unread.badge": "Ungelesene Nachrichten",
                "dashboard.recentInbound.title": "Zuletzt empfangene Nachrichten",
                "dashboard.recentInbound.empty": "Sie haben keine kürzlich empfangenen Nachrichten.",
                "dashboard.recentInbound.error": "Nachrichten konnten nicht geladen werden.",
                "dashboard.recentInbound.previewPhoto": "Foto",
                "dashboard.recentInbound.previewFile": "Archiv",
                "dashboard.recentInbound.previewPdf": "PDF",
                "dashboard.recentInbound.previewUnavailable": "Nachricht nicht verfügbar",
                "dashboard.recentInbound.readTitle": "Lesen",
                "dashboard.recentInbound.unreadTitle": "ungelesen",
                "dashboard.recentConversations.title": "Aktuelle Gespräche",
                "dashboard.recentConversations.empty": "Es sind keine Gespräche vorhanden, die angezeigt werden können.",
                "dashboard.recentConversations.error": "Gespräche konnten nicht geladen werden.",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "Übersetzung nicht verfügbar",
                "plan.errors.translationNotAllowed.message": "Ihr aktueller Plan beinhaltet keine automatische Übersetzung zwischen Sprachen.",
                "plan.errors.translationNotAllowed.solution": "Um die automatische Übersetzung zu verwenden, aktualisieren Sie Ihren Plan.",
                "billing.subscription.cancel_scheduled_date": "Ihr Abonnement wird voraussichtlich am {{date}} gekündigt. Bis dahin können Sie Ihren Plan weiter nutzen.",
                "billing.subscription.cancel_scheduled_badge": "Abgesagt am {{date}}",
                "billing.scheduled.plan_after_cancel_label": "Planen Sie am Ende des Zeitraums:",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "Wechseln Sie zu FOUNDATION",
                "billing.scheduled.switch_to_free": "Wechseln Sie zu KOSTENLOS",
                "billing.scheduled.foundation_full_title": "STIFTUNG nicht verfügbar",
                "billing.scheduled.foundation_full_message": "Derzeit sind keine FOUNDATION-Plätze verfügbar. Am Ende des Zeitraums wird Ihr Plan auf KOSTENLOS reduziert.",
                "billing.scheduled.saving": "Sparen...",
                "billing.scheduled.error_title": "Fehler beim Planwechsel",
                "billing.scheduled.error_generic": "Der geplante Plan konnte nicht geändert werden. Versuchen Sie es erneut.",
                "billing.cancel_scheduled.title": "Geplante Absage",
                "billing.cancel_scheduled.desc": "Ihr Abonnement wird am {{date}} gekündigt. Bis dahin können Sie Ihren aktuellen Plan weiter nutzen.",
                "billing.cancel_scheduled.no_new_plan_until_end": "Bis zum Ablauf dieses Abonnements können Sie keinen weiteren Plan abschließen.",
                "billing.cancel_scheduled.free_fallback": "Wenn Sie einen Plan nicht erneuern, bleibt Ihr Konto KOSTENLOS mit den entsprechenden Einschränkungen bestehen.",
                "billing.cancel_scheduled.profile_deactivation_hint": "Sie können sich auch über Ihr Profil von der Plattform abmelden.",
                "billing.cancel_scheduled.default_free": "Am Ende des Zeitraums: KOSTENLOS",
                "google.missing_client_id": "Die Google-Anmeldung ist in diesem Build nicht verfügbar: VITE_GOOGLE_CLIENT_ID (oder googleClientId pro Mandant in __ARCHAT_TENANT_CONFIG__) fehlt.",
                "reviews.title": "ArChat-Bewertungen",
                "reviews.create_title": "Wie würden Sie ArChat bewerten?",
                "reviews.edit_title": "Bearbeiten Sie meine Bewertung",
                "reviews.comment_placeholder": "Erzählen Sie uns von Ihren Erfahrungen (optional)...",
                "reviews.submit_btn": "Bewertung abgeben",
                "reviews.update_btn": "Aktualisieren",
                "reviews.thank_you": "Vielen Dank für Ihre Bewertung!",
                "reviews.submitted_message": "Ihre Meinung hilft uns, uns zu verbessern.",
                "reviews.error_select_rating": "Wählen Sie eine Bewertung aus",
                "reviews.error_generic": "Fehler beim Senden der Bewertung",
                "reviews.prompt_message": "Gefällt dir ArChat? Hinterlassen Sie Ihre Bewertung!",
                "reviews.rate_now": "Qualifizieren",
                "reviews.later": "Später",
                "reviews.write_review": "Rezension schreiben",
                "reviews.edit_my_review": "Bearbeiten Sie meine Bewertung",
                "reviews.no_reviews": "Es liegen noch keine Bewertungen vor. Seien Sie der Erste!",
                "reviews.review_singular": "Rezension",
                "reviews.review_plural": "Bewertungen",
                "reviews.verified": "Verifiziert",
                "reviews.anonymous": "Anonym",
                "files.storageUsed": "Genutzter Raum",
                "files.planQuota": "Kontingent einplanen",
                "files.availableStorage": "Verfügbar",
                "files.usagePercent": "gebraucht",
                "files.unlimited": "Unbegrenzt",
                "files.sentBy": "Gesendet von",
                "files.unknownUser": "Benutzer",
                "settings.webPushSection": "Systembenachrichtigungen (Push/PWA)",
                "settings.webPushDescription": "Settings.webPushButton': 'Push-Benachrichtigungen aktivieren",
                "settings.webPushRegistering": "Registrieren…",
                "settings.webPushState.denied": "Settings.webPushState.default': 'Tippen Sie auf die Schaltfläche, um die Erlaubnis anzufordern und das Gerät zu registrieren.",
                "settings.webPushState.unsupported": "Dieser Browser unterstützt keine Push-Benachrichtigungen.",
                "subjects.searchTitle": "Suchen Sie in Ausgaben",
                "subjects.searchPlaceholder": "Suche in Angelegenheiten...",
                "tags.etiquetas": "Etiketten",
                "tags.manageTitle": "Tags verwalten",
                "tags.manage": "🏷️ Tags",
                "tags.allTags": "Alle Tags",
                "tags.confirmDelete": "Dieses Tag entfernen?",
                "tags.tagNamePlaceholder": "Tag-Name",
                "tags.create": "Erstellen",
                "tags.noTags": "Es gibt keine Etiketten. Erstellen Sie oben eines.",
                "tags.save": "Halten",
                "tags.edit": "Bearbeiten",
                "tags.delete": "Beseitigen",
                "tags.assignTo": "Zuordnen zu",
                "tags.noTagsToAssign": "Keine Etiketten verfügbar. Erstellen Sie sie zuerst.",
                "tags.bgColor": "Hintergrundfarbe",
                "tags.textColor": "Textfarbe",
                "tags.selectTag": "Wählen Sie ein Etikett aus",
                "templates.selectTitle": "Vorlagen",
                "templates.noTemplates": "Es gibt keine Vorlagen. Erstellen Sie oben eines.",
                "templates.manage": "Vorlagen verwalten",
                "templates.confirmDelete": "Diese Vorlage löschen?",
                "templates.manageTitle": "Vorlagen verwalten",
                "templates.titlePlaceholder": "Vorlagentitel",
                "templates.bodyPlaceholder": "Schreiben Sie die Vorlagennachricht...",
                "templates.create": "Vorlage erstellen",
                "templates.save": "Halten",
                "templates.edit": "Bearbeiten",
                "templates.delete": "Beseitigen",
};


